export default {
  "Dashboard": "لوحة التحكم",
  "Products": "المنتجات",
  "Order": "الطلبات",
  "Stores": "المتاجر المتصلة",
  "Service Ticket": " خدمات مابعد البيع",
  "Pre - order Inventory": "خزنة الحوالات المسبقة",
  "Shipping Ticket": "طلب تعديل معلومات الشحن",
  "Billing": "الفواتير",
  "Pre-order Inventory": " ادارة المخزون",
  "Pre-order Packing": "إدارة مخزون التغليف",
  "Recycled": "طلبات غير منفذة معنا",
  "Third Bound Goods": "المنتجات الحصرية الثالثة",
  "Withdrawal List": "قائمة السحب",
  "My Profile": "ملفي الشخصي",
  "Import List": "قائمة الاستيراد",
  "My Products": "منتجاتي",
  "Quotation": "طلب عرض سعر",
  "Payment": "دفع الطلبات",
  "Shipment": "رمز التتبع",
  "Shipments": "شحنة",
  "Abnormal": "حالة غير طبيعية",
  "Completed": "مكتمل",
  "On Hold": "طلبات متوقفة",
  "Canceled": " كامل الطلبات",
  "All": "كامل الطلبات",
  "Support": "طلبات الدعم",
  "Help": "مساعدة",

  "Announcement": "إعلان",
  "balance": "الرصيد",
  "View Detail": "عرض التفاصيل",
  "wallet": "المحفظة",
  "commission": "العمولة",
  "withdraw": "سحب",
  "system notification": "إشعار النظام",
  "Order Quantity": "كمية الطلب",
  "Commission": "العمولة",
  "Total commission": "إجمالي العمولة",
  "This month Orders": "طلبات الشهر الحالي",
  "This month Revenue": "إيرادات الشهر الحالي",
  "This month Cost": "كلفة الشهر الحالي",
  "Statistics": "إحصاءات",
  "Reference": "مرجع",
  "Date": "التاريخ",
  "Total Orders": "إجمالي الأوامر",
  "Cost": "التكلفة",
  "Show More": "عرض المزيد",
  "Quick Summary": "ملخص سريع",
  "orders": "الطلبات",
  "Waiting to place order": "في انتظار تقديم الطلب",
  "Waiting for tracking code": "في انتظار رمز المتابعة",
  "Authorized": "متصل",
  "Share by APP": "مشاركة من خلال التطبيق",
  "Share": "مشاركة",
  "Scan share to WeChat": "مسح لل مشاركة على وي تشات",
  "Share by link": "مشاركة عبر الرابط",
  "Share link": "رابط المشاركة",
  "Copy Link": "نسخ الرابط",
  "Clear": "مسح",
  "Close": "إغلاق",

  "Your vendor": "موردك",
  "is inviting you to allocate your Orders": "يدعوك لتوزيع أورده",
  "Your store name": "اسم متجرك",
  "Dispatch order method": "طريقة توزيع الطلب",
  "All my unfulfilled / partially fulfilled orders": "جميع أوامري غير المكتملة / المكتملة جزئيا",
  "Cycle time": "مدة الدورة",
  "Every 1 day": "كل 1 يوم",
  "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings": "يمكنك تعديل قواعد توزيع الأوامر في أي وقت من خلال القائمة 'أوامري >> إعدادات توزيع الأوامر'",
  "Remind later": "تذكير لاحقا",
  "I agree": "أنا أوافق",
  "According to your settings, we found some data for you": "وفقاً لاعداداتك، وجدنا بعض البيانات بالنسبة لك",
  "Shopify order": "طلب شوبيفاي",
  "Dispatch in the Next Cycle": "توزيع في الدورة القادمة",
  "Dispatch Immediately": "توزيع على الفور",
  "Revenue": "الأيرادات",
  "You can modify your store settings at any time in the menu 'My Stores'": "يمكنك تعديل إعدادات متجرك في أي وقت من خلال القائمة 'متجراتي'",
  "Newbie": "مبتدئ",
  "Guide": "مرشد",
  "Authorize to bind the store": "أعط صلاحية لربط المتجر",
  "Publish the push product": "نشر المنتج المنشور",

  "Already": "بالفعل",
  "enter": "دخول",
  "offline": "غير متصل",
  "success": "نجاح",
  "Add vendors success": "نجاح في إضافة الموردين",
  "Total Revenue": "إجمالي الأيرادات",
  "Total Cost": "إجمالي التكاليف",
  "Has been copied to the clipboard": "تم نسخها إلىلوحة الحافظة",
  "Copy to clipboard failed, please copy manually": "فشل نسخ إلىلوحة الحافظة، فضلاً قم بنسخ يدوية",

  "Waiting": "قيد الانتظار",
  "Processing": "جارٍ المعالجة",
  "Failed": "فشل",
  "Are you sure you want to push?": "هل أنت متأكد أنك تريد النشر؟",
  "Do you want to delete this task?": "هل تريد حذف هذه المهمة؟",
  "The update  has started, it will take a while to finish.": "تم بدء التحديث، سيستغرق بعض الوقت للانتهاء.",
  "Do you want to delete the product?": "هل تريد حذف هذا المنتج؟",
  "Do you want to Export the product?": "هل تريد تصدير المنتج؟",
  "Export success": "تم التصدير بنجاح",
  "Please select the products": "يرجى اختيار المنتجات",
  "URL required": "الرابط مطلوب",
  "Import success": "تم الاستيراد بنجاح",
  "Please select the tags": "يرجى اختيار العلامات",
  "Tags added successfully": "تمت إضافة العلامات بنجاح",
  "You can import and manage your AliExpress / Amazon products here before publishing them to your Shopify store. You can publish a product to different stores and add multiple tags to each products.": "يمكنك استيراد وإدارة منتجاتك من AliExpress / Amazon هنا قبل نشرها في متجر Shopify الخاص بك. يمكنك نشر المنتج في متاجر مختلفة وإضافة عدة علامات لكل منتج.",
  "Import Aliexpress": "استيراد من AliExpress",
  "Import Product": "استيراد منتج",
  "Product Name": "اسم المنتج",
  "Product Type": "نوع المنتج",
  "Product Pictures": "صور المنتج",
  "Single Value in USD": "القيمة الفردية بالدولار الأمريكي",
  "Gross weight for each Carton": "الوزن الإجمالي لكل كرتونة",
  "Carton Package Size L": "طول الكرتون",
  "Carton Package Size W": "عرض الكرتون",
  "Carton Package Size H": "ارتفاع الكرتون",
  "Single Price": "سعر واحد",
  "Salesman": "بائع",
  "Comment": "تعليق",

  "All Stores": "كل المتاجر",
  "Filter": "فلتر",
  "Push": "نشر",
  "Export": "تصدير",
  "Delete": "حذف",
  "Add Tags": "إضافة علامات",
  "Tag management": "إدارة العلامات",
  "Confirm": "تأكيد",
  "Push Setting": "إعدادات النشر",
  "Upload Progress": "تقدم الرفع",
  "Status": "الحالة",
  "Images": "الصور",
  "Sold Out": "نفد من المخزون",
  "Store Name": "اسم المتجر",
  "Price": "السعر",
  "Supply Unit Price": "سعر وحدة التوريد",
  "Your Price": "سعرك",
  "Fail Reason": "سبب الفشل",
  "Edit": "تعديل",
  "Open in Web": "فتح في المتصفح",
  "no product": "لا يوجد منتج",
  "All Action": "كل الإجراءات",
  "price check": "التحقق من السعر",
  "add related products": "إضافة منتجات ذات صلة",
  "Open in  website": "فتح في الموقع",
  "Retail price": "سعر التجزئة",
  "Supplier price": "سعر المورد",
  "NOT SET": "غير محدد",
  "Shopify store": "متجر Shopify",
  "vendors": "البائعون",
  "You can only upload 5 pictures": "يمكنك رفع 5 صور فقط",
  "Price units default to": "الوحدات السعرية الافتراضية إلى",
  "Please upload pictures": "يرجى رفع الصور",
  "Please enter title": "يرجى إدخال العنوان",
  "Please enter price": "يرجى إدخال السعر",
  "Are you sure you want to delete it?": "هل أنت متأكد أنك تريد حذفه؟",

  "Order Management": "إدارة الطلبات",
  "Waiting For Quote": "انتظر عرض الأسعار",
  "Pay All": "دفع الكل",
  "SKU number/quantity/name": "رقم SKU / الكمية / الاسم",
  "Update Order": "تحديث",
  "Export Order": "تصدير الطلب",
  "Import Order": "استيراد الطلب",
  "Import Product Image": "استيراد صورة المنتج",
  "Order Number": "رقم الطلب",
  "Customer": "العميل",
  "Payment Number": "رقم الدفع",
  "Today": "اليوم",
  "Create Quotation": "إنشاء عرض سعر",
  "Abandon Quotation": "إلغاء عرض السعر",
  "Bulk Payment": "دفع مجمّع",
  "Cancel Payment": "إلغاء الدفع",
  "Manually Sync": "مزامنة يدوية",
  "Continue Pay": "متابعة الدفع",
  "Requote": "عرض السعر مرة أخرى",
  "Product Images": "صور المنتجات",
  "Unable to be sourced": "لا يمكن توفيره",
  "Please make an offer": "يرجى تقديم عرض",
  "Attribute Value": "قيمة الخاصية",
  "Supplier Price": "سعر المورد",
  "Retail Price": "سعر التجزئة",
  "Action": "الإجراء",
  "Remove": "إزالة",
  "offline order": "عرض سعر دون طلبات حالية",
  "Wholesale order": "طلب جملة",
  "Order No.": "رقم الطلب",
  "Created Date": "تاريخ الإنشاء",
  "Shipping Address": "عنوان الشحن",
  "Shipping Method": "طريقة الشحن",
  "Free Shipping": "شحن مجاني",
  "Shipping Cost": "تكلفة الشحن",
  "Total": "الإجمالي",
  "Pay Total": "المبلغ الإجمالي",
  "Quote": "عرض سعر",
  "Pay": "دفع",
  "Split Order": "تقسيم الطلب",
  "After-sales": "ما بعد البيع",
  "Cancel Order": "إلغاء الطلب",
  "Sku/Quantity/Name": "SKU/الكمية/الاسم",
  "Payment No.": "رقم الدفع",
  "Payment Time": "وقت الدفع",
  "Amount": "المبلغ",
  "Countdown": "العد التنازلي",
  "Quantity": "الكمية",
  "Repay": "إعادة الدفع",
  "To Complete Payment": "لإتمام عملية الدفع",
  "Supplier Unit Price": "سعر المورد لكل وحدة",
  "Removed": "تمت الإزالة",
  "Shipping Type": "نوع الشحن",
  "LOGISTICS": "لوجستيات",
  "SELF PICKUP": "الاستلام الذاتي",
  "PREPURCHASE": "شراء مسبق",
  "Order ID": "معرف الطلب",
  "Recover": "استعادة",
  "RecoverAll": "استعادة الكل",
  "Pay with": "الدفع بواسطة",
  "Bonus": "مكافأة",
  "There is no alternative method of payment": "لا توجد طريقة دفع بديلة",
  "Please do not close the page during payment": "يرجى عدم إغلاق الصفحة أثناء الدفع",
  "Close pay": "إغلاق الدفع",
  "Your order has been successfully paid": "تم دفع طلبك بنجاح",
  "The selected orders are abnormal and payment cannot be continued": "الطلبات المحددة غير طبيعية ولا يمكن متابعة الدفع",
  "Payment can continue after excluding the following goods": "يمكن متابعة الدفع بعد استبعاد المنتجات التالية",
  "After removing the off shelf goods, the order will be returned to the": "بعد إزالة المنتجات غير المتوفرة، سيتم إعادة الطلب إلى",
  "price to be quoted": "السعر المطلوب تحديده",
  "Select file": "اختر ملف",
  "Click to download": "انقر للتنزيل",
  "Order Import Template": "نموذج استيراد الطلب",
  "Please fill in the form according to the specification, only xlsx format files are supported": "يرجى تعبئة النموذج وفقًا للمواصفات، الملفات بصيغة xlsx فقط مدعومة",
  "The uploaded file cannot exceed 2M, and only the first 99 data are processed": "لا يمكن أن يتجاوز الملف المرفوع 2 ميجابايت، ويتم معالجة أول 99 صف فقط",
  "submit": "إرسال",
  "Created At": "تاريخ الإنشاء",
  "Cancel": "إلغاء",
  "Waiting for quotation": "في انتظار عرض السعر",
  "Supplier Quote": "عرض سعر المورد",
  "Payment Not Received": "لم يتم استلام الدفع",
  "Pending payment": "الدفع معلق",
  "Unshipped": "لم يتم الشحن",
  "Fulfilled": "تم الشحن",
  "Logistics sync failed": "فشل مزامنة اللوجستيات",
  "Unable to purchase": "غير قابل للشراء",
  "Products off shelf": "منتجات غير متوفرة",
  "Payment unfinished": "الدفع غير مكتمل",
  "Payment to be completed": "يجب إكمال الدفع",
  "Waiting for fulfill": "في انتظار التنفيذ",
  "Quit quotation": "إلغاء عرض السعر",
  "Payment failed": "فشل الدفع",
  "Vendor Verifying Payment": "البائع يتحقق من الدفع",
  "Payment result to be returned": "نتيجة الدفع قيد الإرجاع",
  "Remove the product": "إزالة المنتج",
  "Removed the product successful": "تمت إزالة المنتج بنجاح",
  "Delete Successful": "تم الحذف بنجاح",
  "Please select an order first": "يرجى اختيار طلب أولاً",
  "Sure to delete this item?": "هل أنت متأكد من حذف هذا العنصر؟",
  "Delete Successful!": "تم الحذف بنجاح!",
  "Please select an order": "يرجى اختيار طلب",
  "Please choose file": "يرجى اختيار ملف",
  "Create Success": "تم الإنشاء بنجاح",
  "No goods need to be eliminated": "لا توجد منتجات يجب إزالتها",
  "No logistics": "لا توجد لوجستيات",
  "Are you sure to abandon payment for the selected order? After abandoning, the order will disappear from the list, which cannot be restored, please operate with caution": "هل أنت متأكد من إلغاء الدفع لهذا الطلب؟ بعد الإلغاء، سيختفي الطلب من القائمة ولن يمكن استعادته. يرجى توخي الحذر.",
  "No Purchase": "إلغاء طلب عرض السعر",
  "Unpaid Order": "جاهز للدفع",
  "Payment Initiated but Unpaid": "تم بدء الدفع ولكن لم يتم السداد",
  "Payment Made but Not Received": "تم الدفع ولكن لم يتم استلامه",
  "The receiving address has no logistics method set": "عنوان الاستلام لا يحتوي على طريقة شحن محددة",
  "The order is below the minimum deliverable weight": "الطلب أقل من الحد الأدنى للوزن القابل للتوصيل",
  "The order is below the minimum deliverable volume": "الطلب أقل من الحد الأدنى للحجم القابل للتوصيل",
  "The order is higher than the maximum deliverable weight": "الطلب أعلى من الحد الأقصى للوزن القابل للتوصيل",
  "The order is higher than the maximum deliverable volume": "الطلب أعلى من الحد الأقصى للحجم القابل للتوصيل",
  "The following product attributes of this order do not meet the attribute requirements of deliverable products": "سمات المنتج التالية في هذا الطلب لا تفي بمتطلبات سمات المنتجات القابلة للتوصيل",
  "The total weight of the goods in this order does not meet the deliverable requirements": "إجمالي وزن البضائع في هذا الطلب لا يفي بمتطلبات التوصيل",
  "Weight": "الوزن",
  "Total weight": "إجمالي الوزن",
  "Attribute": "السمة",
  "I Know": "أفهم",
  "Card Number": "رقم البطاقة",
  "Expiration": "تاريخ الانتهاء",
  "Payment amount": "قيمة الدفع",
  "Payment instructions": "تعليمات الدفع",
  "Other details": "تفاصيل أخرى",
  "Payment account": "حساب الدفع",
  "Payment voucher": "إثبات الدفع",
  "Add Tracking": "إضافة تتبع",
  "Track number": "رقم التتبع",
  "Please input the tracking number": "يرجى إدخال رقم التتبع",
  "Track company": "شركة التتبع",
  "Your request has been sent": "تم إرسال طلبك",

  "My Stores": "متاجري",
  "Add a new store": "إضافة متجر جديد",
  "Creation date": "تاريخ الإنشاء",
  "Auth date": "تاريخ التفويض",
  "Remove entrusted vendor": "إزالة المورد المفوض",
  "Reauthorize": "إعادة التفويض",
  "Coming Soon": "قريبًا",
  "vendor is authorizing the store on BCNDropshipping App, please be noted.": "المورد يقوم بتفويض المتجر على تطبيق BCNDropshipping، يرجى الانتباه.",
  "If you do not check the relevant permissions, it will affect the use of related functions, please operate with caution": "إذا لم تقم بتحديد الأذونات ذات الصلة، فسيؤثر ذلك على استخدام الوظائف المتعلقة، يرجى الحذر.",
  "Connect": "اتصال",
  "Are you sure you want to cancel the hosting store": "هل أنت متأكد أنك تريد إلغاء استضافة المتجر؟",
  "after you close the hosting, the supplier will not be able to actively quote your order!": "بعد إغلاق الاستضافة، لن يتمكن المورد من تقديم عروض لطلباتك!",
  "Sure": "تأكيد",
  "You have successfully hosted the store": "تم استضافة المتجر بنجاح",
  "After the successful hosting, your supplier will take the initiative to quote for your pending orders!": "بعد الاستضافة الناجحة، سيقوم المورد بتقديم عروض تلقائيًا للطلبات المعلقة!",
  "Choose a vendor": "اختر مورّدًا",
  "Select": "اختر",
  "No Data": "لا توجد بيانات",
  "Save": "حفظ",
  "Add a new vendor": "إضافة مورّد جديد",
  "Customer name required": "اسم العميل مطلوب",
  "customers successfully added": "تمت إضافة العملاء بنجاح",
  "Are you sure you want to remove entrusted vendor?": "هل أنت متأكد من أنك تريد إزالة المورد المفوض؟",
  "After-sales Ticket": "طلبات خدمات مابعد البيع",
  "Ticket Type": "نوع الطلب",
  "Customer Name": "اسم العميل",
  "Approval": "الموافقة",
  "Transaction Type": "نوع المعاملة",
  "Question Type": "نوع المشكلة",
  "Problem Description": "وصف المشكلة",
  "Refund": "استرداد",
  "Replacement": "استبدال",
  "modify the related information for customer": "تعديل المعلومات ذات الصلة للعميل",
  "cancel order": "إلغاء الطلب",
  "No tracking information": "لا توجد معلومات تتبع",
  "Tracking information not update too long time": "معلومات التتبع لم يتم تحديثها لفترة طويلة",
  "Item damage": "تلف في المنتج",
  "Item missing": "منتج مفقود",
  "Send wrong product": "تم إرسال منتج خاطئ",
  "Send wrong address": "تم الإرسال إلى عنوان خاطئ",
  "On hold order": "طلب قيد الانتظار",
  "optional": "اختياري",
  "Order Information": "معلومات الطلب",
  "Third party order number": "رقم الطلب من طرف ثالث",
  "Creation time": "وقت الإنشاء",
  "On Hold Order": "طلب معلق",
  "Resend Item": "إعادة إرسال المنتج",
  "Refund Item": "استرداد المنتج",
  "agree": "موافقة",
  "Ticket No.": "رقم التذكرة",
  "please enter": "يرجى الإدخال",
  "Approval Status": "حالة الموافقة",
  "Await Review": "بانتظار المراجعة",
  "Reject": "رفض",
  "Pass": "تمت الموافقة",
  "Missing Item": "عنصر مفقود",
  "Wrong Product": "منتج خاطئ",
  "Modify the related information for customer": "تعديل المعلومات ذات الصلة للعميل",
  "Change color/size": "تغيير اللون/الحجم",
  "Change Product": "تغيير المنتج",
  "Payment Issues": "مشاكل الدفع",
  "Voucher": "قسيمة",
  "Transaction": "معاملة",
  "normal bill": "فاتورة عادية",
  "Create Time": "وقت الإنشاء",
  "Yesterday": "أمس",
  "Last 7 days": "آخر 7 أيام",
  "Payment Code": "رمز الدفع",
  "Third Party Number": "رقم الطرف الثالث",
  "Trade type": "نوع المعاملة",
  "Trade status": "حالة المعاملة",
  "Account payee": "صاحب الحساب",
  "Order number": "رقم الطلب",
  "Remark": "ملاحظة",
  "Trade amount": "قيمة المعاملة",
  "Payment type": "نوع الدفع",
  "Operate": "تشغيل",
  "abnormal bill": "فاتورة غير طبيعية",
  "View detail": "عرض التفاصيل",
  "download PDF": "تحميل PDF",
  "The export of time": "تاريخ التصدير",
  "Petitioner": "المتقدم",
  "Payment order": "طلب الدفع",
  "Refund order": "طلب استرداد",
  "Wallet card": "بطاقة المحفظة",
  "Manual deduction": "خصم يدوي",
  "Paying": "جارٍ الدفع",
  "Account paid": "تم الدفع من الحساب",
  "Refunded": "تم الاسترداد",
  "Invoice Pay": "دفع الطلب",
  "Refund Order": "استرداد الطلب",
  "Bonus Recharge": "شحن المكافآت",
  "Bonus Deduction": "خصم المكافآت",
  "unpaid": "معلّق",
  "paid": "مدفوع",
  "refund": "استرداد",
  "canceled": "ملغي",
  "Pre-order stock order": "طلب مخزون مسبق",
  "pleaseCusName": "يرجى إدخال اسم العميل",
  "Withdrawal list": "قائمة السحب",
  "Withdrawal method": "طريقة السحب",
  "CreateDate": "تاريخ الإنشاء",
  "startDate": "تاريخ البدء",
  "endDate": "تاريخ الانتهاء",
  "accountPayee": "صاحب الحساب",
  "customersName": "اسم العميل",
  "Warning Tips": "نصائح تحذيرية",
  "Withdrawal Amount": "مبلغ السحب",
  "reject": "رفض",
  "Pending": "معلق",
  "Approved": "موافق عليه",
  "GENERAL INFORMATION": "معلومات عامة",
  "CONTACT": "معلومات الاتصال",
  "Change": "تغيير",
  "ADD": "إضافة",
  "SOCIAL": "معلومات التواصل الاجتماعي",
  "Notification Settings": "إعدادات الإشعارات",
  "I want to receive notfications by": "أرغب في تلقي الإشعارات عبر",
  "Mobile phone": "الهاتف المحمول",
  "Allow system notifhcations": "السماح بإشعارات النظام",
  "Allow Customer Services from": "السماح بخدمة العملاء من",
  "Allow Dropshipping News": "السماح بأخبار الدروبشيبينغ",
  "Reset All": "إعادة تعيين الكل",
  "Save Changes": "حفظ التغييرات",
  "try again in": "حاول مرة أخرى خلال",
  "seconds": "ثواني",
  "Discard": "إلغاء",


  "Login/Register": "تسجيل الدخول / التسجيل",
  "Logout": "تسجيل الخروج",
  "Powered by COMEXBCN-BCN DROPSHIPPING": "مشغل بواسطة COMEXBCN - BCN دروبشيبينغ",
  "Home": "الصفحة الرئيسية",
  "PRIVACY POLICY": "سياسة الخصوصية",
  "SHIPPING POLICY": "سياسة الشحن",
  "TERMS AND CONDITIONS OF USE": "الشروط والأحكام",
  "RETURN AND REFUND POLICY": "سياسة الإرجاع والاسترداد",
  "CONTACT US": "اتصل بنا",
  "Category Name": "اسم الفئة",
  "More": "المزيد",
  "Product category name": "اسم فئة المنتج",
  "Waiting for the payment result to be returned.": "بانتظار نتيجة الدفع.",
  "You may need to wait a little while": "قد تحتاج إلى الانتظار قليلاً",
  "Payment successful": "تم الدفع بنجاح",
  "You have successfully completed your order": "لقد أكملت طلبك بنجاح",
  "View order": "عرض الطلب",
  "Sorry, we can't complete the payment.": "عذرًا، لا يمكننا إكمال الدفع.",
  "Add New Address": "إضافة عنوان جديد",
  "Product Details": "تفاصيل المنتج",
  "Please check the purchase produc": "يرجى التحقق من المنتج المشتَرى",
  "out of stock": "غير متوفر",
  "Inventory": "المخزون",
  "Subtotal": "الإجمالي الفرعي",
  "Freight": "الشحن",
  "Credits": "الرصيد",
  "Combination payment": "دفع مشترك",
  "Please enter the balance to be used": "يرجى إدخال الرصيد المراد استخدامه",
  "Rules: The input amount should be less than the order amount, and only two decimal places": "القواعد: يجب أن يكون المبلغ المدخل أقل من مبلغ الطلب، وبحد أقصى منزلتين عشريتين",
  "Payment method": "طريقة الدفع",
  "Amount due (including freight)": "المبلغ المستحق (بما في ذلك الشحن)",
  "Submit orders": "إرسال الطلب",
  "Please select payment method": "يرجى اختيار طريقة الدفع",
  "First Name": "الاسم الأول",
  "Please enter the first name": "يرجى إدخال الاسم الأول",
  "Last Name": "اسم العائلة",
  "Please enter the last name": "يرجى إدخال اسم العائلة",
  "Please enter the address": "يرجى إدخال العنوان",
  "Please enter the country": "يرجى إدخال الدولة",
  "Please enter the province": "يرجى إدخال المنطقة",
  "Please enter the city": "يرجى إدخال المدينة",
  "Please enter the phone": "يرجى إدخال رقم الهاتف",
  "Please enter the postcode": "يرجى إدخال الرمز البريدي",
  "Set as default shipping address": "تعيين كعنوان شحن افتراضي",
  "Reset": "إعادة تعيين",
  "Search Product": "بحث عن منتج",
  "History": "السجل",
  "Publish": "تقديم الطلب",
  "Sign up here": "سجّل هنا",
  "Sign in": "تسجيل الدخول",
  "Forgot your password?": "هل نسيت كلمة المرور؟",
  "or Sign in with": "أو تسجيل الدخول باستخدام",
  "Already have an account?": "هل لديك حساب بالفعل؟",
  "Products Market": "سوق المنتجات",
  "Unit Price": "سعر الوحدة",
  "GO": "اذهب",
  "Qty Available": "الكمية المتوفرة",
  "First Available": "أول توفر",
  "Last 14 days": "آخر 14 يومًا",
  "Last 30 days": "آخر 30 يومًا",
  "Sort by": "ترتيب حسب",
  "There are no products in this category": "لا توجد منتجات في هذه الفئة",
  "Please enter your shopify store name to connect the dashboard page": "يرجى إدخال اسم متجرك في شوبيفاي للاتصال بصفحة لوحة التحكم",
  "Stock Qty": "كمية المخزون",
  "VAT information": "معلومات ضريبة القيمة المضافة",
  "you can click": "يمكنك النقر",
  "for VAT information": "للحصول على معلومات ضريبة القيمة المضافة",
  "Shipping": "الشحن",
  "Shipping to": "الشحن إلى",
  "Please select": "يرجى الاختيار",
  "Shipping fee": "رسوم الشحن",
  "Quality": "الجودة",
  "inventory": "المخزون",
  "Add to List": "أضف إلى القائمة",
  "Add to Cart": "أضف إلى السلة",
  "Specifications": "المواصفات",
  "Download the attachment": "تحميل المرفق",
  "product information": "معلومات المنتج",
  "Product category": "فئة المنتج",
  "product name": "اسم المنتج",
  "Specification": "المواصفة",
  "material": "المادة",
  "size": "الحجم",
  "weight": "الوزن",
  "The tax-inclusive price of an item is calculated based on the item price set by the seller and the applicable tax rate. You can contact the seller for more details.": "يتم حساب السعر الشامل للضريبة بناءً على سعر المنتج المحدد من البائع ومعدل الضريبة المعمول به. يمكنك الاتصال بالبائع لمزيد من التفاصيل.",
  "You have authorized a Shopify store,you could": "لقد قمت بتفويض متجر شوبيفاي، يمكنك",
  "to view details": "لعرض التفاصيل",
  "authorize to login": "تفويض لتسجيل الدخول",
  "If it is necessary to process your shopify order or to achieve an automatically update for the shipping information to shopify, you could": "إذا كان من الضروري معالجة طلبك في شوبيفاي أو تحديث معلومات الشحن تلقائيًا في شوبيفاي، يمكنك",
  "connect your Shopify store": "ربط متجر شوبيفاي الخاص بك",
  "and let us help you": "ودعنا نساعدك",
  "If you have authorized a Shopify store, after the vendor delivers the items, the shipping information will been synchronized to your Shopify store which you had authorized.": "إذا كنت قد فوضت متجر شوبيفاي، فبعد أن يقوم المورد بشحن المنتجات، سيتم مزامنة معلومات الشحن مع المتجر الذي قمت بتفويضه.",
  "If there are some Shopify stores in the order list below that have not been authorized, you can": "إذا كانت هناك متاجر شوبيفاي في قائمة الطلبات أدناه لم يتم تفويضها، يمكنك",
  "authorize a new one": "تفويض متجر جديد",
  "If you need to view your recent orders, please click": "إذا كنت بحاجة لعرض طلباتك الأخيرة، يرجى النقر",
  "Cancelled": "ملغي",
  "Purchase Order": "طلب شراء",
  "Tell us more about your request": "أخبرنا بالمزيد عن طلبك",
  "Attach image file": "إرفاق ملف صورة",
  "Browse": "تصفح",
  "What is your store name?": "ما هو اسم متجرك؟",
  "Customer Support Email": "البريد الإلكتروني لخدمة العملاء",
  "Send your request": "إرسال طلبك",
  "Getting Started": "البدء",
  "Main Features": "الميزات الرئيسية",
  "Please enter Shopify store name": "يرجى إدخال اسم متجر شوبيفاي",
  "The email must not be empty": "البريد الإلكتروني لا يجب أن يكون فارغًا",
  "Send Success,We will contact you soon.": "تم الإرسال بنجاح، سنتواصل معك قريبًا.",

  "Total Payment": "إجمالي الدفع",
  "Total Merchandise": "إجمالي البضائع",
  "SKU Details": "تفاصيل رمز المنتج (SKU)",
  "Commodity Price": "سعر السلعة",
  "Subscribe to our newsletter": "اشترك في النشرة البريدية",
  "Promotions, new products and sales. Directly to your inbox.": "عروض وتخفيضات ومنتجات جديدة مباشرة إلى بريدك الإلكتروني.",
  "Your email": "بريدك الإلكتروني",
  "Subscribe": "اشترك",
  "Company Information": "معلومات الشركة",
  "OUR SOCIAL MEDIA": "وسائل التواصل الاجتماعي",
  "PRIVACY STATEMENT": "بيان الخصوصية",
  "Terms and Conditions": "الشروط والأحكام",
  "My  Profile": "ملفي الشخصي",
  "Login": "تسجيل الدخول",
  "Please contact the supplier to improve the external number of the webmaster": "يرجى التواصل مع المورد لتحسين الرقم الخارجي للمسؤول",
  "Black": "أسود",
  "There are currently no products under this category": "لا توجد منتجات حالياً ضمن هذه الفئة",
  "Logo": "اللوغو",
  "You can find the recent quotationsand check offers": "يمكنك العثور على أحدث العروض والتحقق من الأسعار",
  "Maximum recommended size 200px * 200px, image can be adapted": "الحجم الموصى به هو 200×200 بكسل، ويمكن تعديل الصورة",
  "Add image": "إضافة صورة",
  "Change image": "تغيير الصورة",
  "Shopify tags": "الوسوم",
  "New Tag": "وسم جديد",
  "Shopify type": "نوع المنتج",
  "Loading": "جارٍ التحميل",
  "Compare Price": "سعر المقارنة",
  "Cost Price": "سعر التكلفة",
  "Sale Price": "سعر البيع",
  "Product Cost": "تكلفة المنتج",
  "incorrect input": "إدخال غير صحيح",
  "Tag name": "اسم الوسم",
  "Distributor commission withdrawal": "سحب عمولة الموزع",
  "Please enter the commission withdrawal amount": "يرجى إدخال مبلغ سحب العمولة",
  "Please enter content": "يرجى إدخال المحتوى",
  "tradeAmount": "قيمة الصفقة",
  "itemAmount": "قيمة العناصر",
  "discountAmount": "قيمة الخصم",
  "refundAmount": "قيمة الاسترداد",
  "to": "إلى",
  "Selected stores": "المتاجر المحددة",
  "Please select the Shopify stores": "يرجى تحديد متاجر شوبيفاي",
  "Shopify": "شوبيفاي",
  "Woocommerce": "ووكومرس",
  "Lazada": "لازادا",
  "Shopee": "شوبي",
  "Change All": "تغيير الكل",
  "Multiply Price": "ضرب السعر",
  "Add Price": "إضافة سعر",
  "Wayfair": "وايفير",
  "Push to Store": "دفع إلى المتجر",
  "Add Cost Range": "إضافة نطاق تكلفة",
  "Plus": "إضافة",
  "Multiply": "ضرب",
  "Fixed Price": "سعر ثابت",
  "You can set a specific cent value for your price or comparison": "يمكنك تحديد قيمة سنت معينة للسعر أو المقارنة",
  "price.": "السعر.",
  "Assign Cent": "تعيين سنت",
  "Assign compare at Cent": "تعيين سنت المقارنة",
  "According to store currency": "وفقاً لعملة المتجر",
  "Apply for products in Import List": "تطبيق على المنتجات في قائمة الاستيراد",
  "Add New Tags": "إضافة وسوم جديدة",
  "Are you sure to delete it": "هل أنت متأكد من الحذف؟",
  "Please enter the New tag": "يرجى إدخال الوسم الجديد",
  "error": "خطأ",
  "Do you want to delete the": "هل تريد حذف",
  "product(s)?": "المنتج/المنتجات؟",
  "Delete success": "تم الحذف بنجاح",
  "Do you want to Export the": "هل تريد تصدير",
  "Unit Cost": "تكلفة الوحدة",
  "Import Aliexpress'": "أدخل رابط منتج Aliexpress / Amazon واضغط 'استيراد المنتج'",
  "Product SKU": "رمز المنتج (SKU)",
  "Not purchased": "غير مشتراة",
  "Cost per unit": "تكلفة الوحدة",
  "Clear selection": "مسح التحديد",
  "Total Quantity selected": "إجمالي الكمية المحددة",
  "Total Quantity": "إجمالي الكمية",
  "Total Cartons": "إجمالي الكراتين",
  "Total CBM": "إجمالي متر مكعب",
  "You can find the recent quotations and check offers": "يمكنك العثور على أحدث العروض والتحقق من الأسعار",
  "Waiting for vendors respond": "بانتظار رد البائعين",
  "Vendors responding quotations": "البائعون يستجيبون للعروض",
  "Archived quotations": "العروض المؤرشفة",
  "Attachment file": "ملف المرفق",
  "Partially Fulfilled": "تم التنفيذ جزئياً",
  "Single": "أعزب",
  "Multiple": "عديد",
  "Inculding supplier PL or PI": "بما في ذلك المورد PL أو PI",
  "Sale name": "اسم البيع",
  "Description": "وصف",
  "Last 90 days": "آخر 90 يومًا",
  "Last 12 months": "آخر 12 شهرًا",
  "Custom": "مخصص",
  "Order number (ascending)": "رقم الطلب (تصاعدي)",
  "Order number (descending)": "رقم الطلب (تنازلي)",
  "Date (oldest first)": "التاريخ (الأقدم أولاً)",
  "Date (newest first)": "التاريخ (الأحدث أولاً)",
  "Partially refunded": "تم استرداد جزء من المبلغ",
  "orders selected": "طلبات محددة",
  "orders selected, uncheck": "طلبات محددة، إلغاء التحديد",
  "orders selected, select all": "طلبات محددة، تحديد الكل",
  "Only orders in": "فقط الطلبات في",
  "Paid": "مدفوع",
  "No order selected": "لم يتم تحديد أي طلب",
  "Create quotation request": "إنشاء طلب عرض سعر",
  "can": "يمكن",
  "waiting for responding": "بانتظار الرد",
  "Confirmed": "تم التأكيد",
  "ID Range": "نطاق المعرفات",
  "Order Includes": "يتضمن الطلب",
  "View offers": "عرض العروض",
  "Cancel offers": "إلغاء العروض",
  "Check offers": "تحقق من العروض",
  "My Store": "متجري",
  "Fulfillment": "التنفيذ",
  "Allocate": "تخصيص",
  "button of the page,you can also allocate items from the same SPU to the same vendor": "زر الصفحة، يمكنك أيضًا تخصيص العناصر من نفس SPU لنفس المورد",
  "Items": "العناصر",
  "Details": "التفاصيل",
  "Expected price (US$)": "السعر المتوقع (دولار أمريكي)",
  "Vendors respond": "رد الموردين",
  "Purchase Order Reconfirm": "إعادة تأكيد أمر الشراء",
  "Vendor name": "اسم المورد",
  "AilExpress shop": "متجر علي إكسبرس",
  "Invite Vendor": "دعوة المورد",
  "Invite Link:": "رابط الدعوة:",
  "Bonus Detail": "تفاصيل المكافأة",
  "Amount($)": "المبلغ (دولار)",
  "Product name": "اسم المنتج",
  "Enter order number": "أدخل رقم الطلب",
  "Product information": "معلومات المنتج",
  "Edit Product": "تعديل المنتج",
  "Shopify vendor": "المورد",
  "What is your Email?": "ما هو بريدك الإلكتروني؟",
  "Cancel purchase order": "إلغاء أمر الشراء",
  "Use this button to update if missing orders.The process may take a while to finish.": "استخدم هذا الزر لتحديث الطلبات المفقودة. قد تستغرق العملية بعض الوقت.",
  "Offered Orders": "الطلبات المعروضة",
  "Offered Products": "المنتجات المعروضة",
  "Offer price": "سعر العرض",
  "View offer detail": "عرض تفاصيل العرض",
  "Hold down the slider and drag to the right": "اضغط باستمرار على الشريط واسحب لليمين",
  "In order to keep you informed of the update of the order, we suggest you verify the email": "لإبلاغك بتحديث الطلب، ننصحك بالتحقق من البريد الإلكتروني",
  "orders can be process, what do you want to do now?": "يمكن معالجة الطلبات، ماذا تريد أن تفعل الآن؟",
  "Need new quotation for my orders": "أحتاج إلى عرض سعر جديد لطلباتي",
  "Over 30000+ vendors waiting for offer you price": "أكثر من 30000 مورد بانتظار تقديم أسعار لك",
  "Allocate my exist vendors": "تخصيص لموردي الحاليين",
  "Just check my orders": "فقط تحقق من طلباتي",
  "If you already have cooperative vendors, you can allocate orders to them": "إذا كان لديك موردون متعاونون، يمكنك تخصيص الطلبات لهم",
  "How to process your orders?": "كيف تريد معالجة طلباتك؟",
  "Please select at least one order and quote for your order": "يرجى تحديد طلب واحد على الأقل وتقديم عرض سعر له",
  "Confirm this Offer": "تأكيد هذا العرض",
  "All Orders": "جميع الطلبات",
  "All Products": "جميع المنتجات",
  "Yes, I want to CANCEL this offer": "نعم، أريد إلغاء هذا العرض",
  "Cancel the success": "تم الإلغاء بنجاح",
  "Volume(cm)": "الحجم (سم)",
  "Total volume(cm)": "إجمالي الحجم (سم)",
  "You have successfully completed your order.": "لقد أتممت طلبك بنجاح.",
  "Pay again": "الدفع مرة أخرى",
  "Receiving": "الاستلام",
  "days": "أيام",
  "Shipping days ": "أيام الشحن",
  "Discount": "الخصم",
  "Exchange": "الاستبدال",
  "The supplier has opened a credit limit for you. When your account balance is insufficient, you can deduct the credit limit": "قام المورد بفتح حد ائتماني لك. عند نفاد رصيد حسابك، يمكنك استخدام هذا الحد.",
  "Quantity of order ": "كمية الطلب",
  "Total amount of goods": "إجمالي قيمة البضائع",
  "Tax Amount": "قيمة الضريبة",
  "Discounted price of goods": "السعر بعد الخصم",
  "Total freight amount": "إجمالي الشحن",
  "Shop discount": "خصم المتجر",
  "This document is free of freight": "هذا المستند خالٍ من رسوم الشحن",
  "credit&debit card": "بطاقة ائتمان / خصم",
  "qr payment": "دفع عبر رمز QR",
  "Your No.": "رقمك",
  "Create Quote": "إنشاء عرض سعر",
  "Bulk payment": "دفع جماعي",
  "Shop price": "سعر المتجر",
  "warehouse": "المستودع",
  "address": "العنوان",
  "Product": "المنتج",
  "Manually synced": "تم المزامنة يدويًا",
  "Payment time": "وقت الدفع",
  "Inventory lock remaining time": "الوقت المتبقي لقفل المخزون",
  "Order quantity": "كمية الطلب",
  "Cancel payment": "إلغاء الدفع",
  "Request Fullfill": "طلب تنفيذ",
  "Paid Time": "وقت الدفع",
  "Deliver Time": "وقت التسليم",
  "Select Payment Method": "اختر وسيلة الدفع",
  "All transactions are secure and encrypted": "جميع المعاملات آمنة ومشفرة",
  "Quotation to be submitted": "عرض السعر الذي سيتم تقديمه",
  "Quoted": "طلبات المتجر",
  "Unfulfilled": "لم يتم الشحن بعد",
  "danger": "خطر",
  "Delivery Address": "عنوان التسليم",
  "warning": "تحذير",
  "Binding succeeded!": "تم الربط بنجاح!",
  "There is no warehouse, please go to add!": "لا يوجد مستودع، يرجى الإضافة!",
  "file cannot over 2MB": "الملف لا يمكن أن يتجاوز 2 ميجابايت",
  "Please select an order firs": "يرجى تحديد طلب أولاً",
  "Successfully": "بنجاح",
  "Are you sure to initiate a quotation for the selected order?": "هل أنت متأكد من بدء عرض السعر للطلب المحدد؟",
  "Are you sure to abandon the quotation for the selected order? After giving up, it cannot be restored, please operate with caution": "هل أنت متأكد من التخلي عن عرض السعر للطلب المحدد؟ بعد التخلي، لا يمكن استعادته، يرجى الحذر",
  "Payment has not arrived": "لم يتم استلام الدفع",
  "Awaiting Fulfillment": "بانتظار التنفيذ",
  "SortBy": "ترتيب حسب",
  "Date Ranges": "نطاق التواريخ",
  "Export to": "تصدير إلى",
  "Selected": "محدد",
  "Some orders had been fulfilled or refunded": "تم تنفيذ أو استرداد بعض الطلبات",
  "Export orders": "تصدير الطلبات",
  "Abnormal reason": "سبب غير طبيعي",
  "Date type": "نوع التاريخ",
  "Download tracking information": "تنزيل معلومات التتبع",
  "Depending on how many Orders you're exporting,this could take some time.": "اعتمادًا على عدد الطلبات التي تقوم بتصديرها، قد يستغرق هذا بعض الوقت.",
  "<strong>Your Orders are exporting</strong><br/>Your export will be delivered by email to: . <br/>Depending on how many Orders you're exporting, this could take some time.": "<strong>يتم تصدير طلباتك</strong><br/>سيتم إرسال التصدير إلى بريدك الإلكتروني: .<br/>اعتمادًا على عدد الطلبات، قد يستغرق ذلك بعض الوقت.",
  "Notice": "إشعار",
  "purchase order(s) need your reconfirm,": "أوامر الشراء بحاجة لتأكيد منك،",
  "click here": "اضغط هنا",
  "to view details.": "لعرض التفاصيل.",
  "Vendor shipped": "تم الشحن من المورد",
  "unfulfilled / partially fulfilled)": "لم يتم التنفيذ / تم التنفيذ جزئيًا",
  "But": "لكن",

  "You may download these tracking information and fulfilled these orders in your Shopify store manualy.": "يمكنك تنزيل هذه المعلومات وتتبع الطلبات وإتمامها يدويًا في متجرك على شوبيفاي.",
  "Download ALL tracking information": "تنزيل جميع معلومات التتبع",
  "Reconfirm": "إعادة تأكيد",
  "Cancel this order": "إلغاء هذا الطلب",
  "NOT Joined": "لم ينضم",
  "Not set up": "لم يتم الإعداد",
  "View Details": "عرض التفاصيل",
  "Send to vendor": "إرسال إلى المورد",
  "Title": "العنوان",
  "Order Title": "اسم المنتج",
  "Select country": "اختر البلد",
  "Desc": "الوصف",
  "Feedback": "ملاحظات",
  "Includes": "يشمل",
  "Shopify orders": "طلبات شوبيفاي",
  "products": "المنتجات",
  "invalid": "غير صالح",
  "Income": "الدخل",
  "Income will only visible to you": "الدخل سيكون مرئيًا لك فقط",
  "Allow vendor to process these orders": "السماح للمورد بمعالجة هذه الطلبات",
  "Do you want to cancel this order?": "هل تريد إلغاء هذا الطلب؟",
  "Don't worry, after cancelling this purchase order, you can still find your": "لا تقلق، بعد إلغاء هذا الطلب، يمكنك العثور على طلباتك",
  "Shopify orders in the 'Waiting for sourcing' menu and re-place the purchase order": "طلبات شوبيفاي في قائمة 'انتظار التوريد' وإعادة طلب الشراء",
  "Change purchase order to another vendor": "تغيير طلب الشراء إلى مورد آخر",
  "Current vendor:": "المورد الحالي:",
  "Change to new vendor": "التغيير إلى مورد جديد",
  "All my vendors": "جميع مورديّ",
  "Also allocate the products in this purchase order to the new supplier": "تخصيص المنتجات في هذا الطلب إلى المورد الجديد أيضًا",
  "Order created": "تم إنشاء الطلب",
  "Order paid": "تم دفع الطلب",
  "Login to your": "تسجيل الدخول إلى حسابك",
  "Order confirmed": "تم تأكيد الطلب",
  "Your request is been submitted, please wait one moment.": "تم تقديم طلبك، يرجى الانتظار لحظة.",
  "The update process has started, it will take a while to finish.": "تم بدء عملية التحديث، ستستغرق بعض الوقت لإكمالها.",
  "You have": "لديك",
  "purchase orders": "طلبات الشراء",
  "NEED to finish payment": "يجب إتمام الدفع",
  "Waiting for allocated": "في انتظار التخصيص",
  "Waiting for sourcing ": "في انتظار التوريد",
  "Orders processing": "معالجة الطلبات",
  "Abnormal order ": "طلب غير طبيعي",
  "Quote for Orders": "عرض أسعار للطلبات",
  "Quote for Product": "عرض أسعار للمنتجات",
  "Recent Quotations": "العروض الأخيرة",
  "orders matching your search": "الطلبات التي تطابق بحثك",
  "SPU": "SPU",
  "Store": "المتجر",
  "Email": "البريد الإلكتروني",
  "Get captcha": "الحصول على كود التحقق",
  "Please fill in the correct Email address": "يرجى إدخال عنوان البريد الإلكتروني الصحيح",
  "User Email modified successfully": "تم تعديل بريد المستخدم الإلكتروني بنجاح",
  "Your Orders are exporting</strong><br/>Your export will be delivered by email to": "يتم تصدير طلباتك</strong><br/>سيتم إرسال التصدير إلى بريدك الإلكتروني إلى",
  "<br/>Depending on how many Orders you're exporting, this could take some time": "<br/>اعتمادًا على عدد الطلبات التي تقوم بتصديرها، قد يستغرق ذلك بعض الوقت",
  "Show cancelled orders": "عرض الطلبات الملغاة",
  "Show all valid orders": "عرض جميع الطلبات الصالحة",
  "unfulfilled / partially fulfilled": "غير مكتمل / مكتمل جزئيًا",
  "Download NOT FULFILLED tracking information": "تنزيل معلومات التتبع غير المكتملة",
  "sync failed": "فشل المزامنة",
  "Change another vendor": "تغيير إلى مورد آخر",
  "Invite vendor to process": "دعوة المورد لمعالجة الطلبات",
  "More Action": "مزيد من الإجراءات",
  "Selected saved! Now you can Check the purchase orders": "تم حفظ الاختيارات! الآن يمكنك التحقق من طلبات الشراء",
  "After your confirmation for the payment, we will notify the vendor by email. You can also proactively notify the vendor to speed the delivery up": "بعد تأكيدك للدفع، سنقوم بإبلاغ المورد عبر البريد الإلكتروني. يمكنك أيضًا إعلام المورد بشكل استباقي لتسريع التسليم",
  "Have you finished the payment?": "هل انتهيت من الدفع؟",
  "Confirm the payment": "تأكيد الدفع",
  "The reason must be entered": "يجب إدخال السبب",
  "In this tab, we will only filter your": "في هذه التبويب، سنقوم بتصفية",
  "Orders which you can allocate to your vendor to process.": "الطلبات التي يمكنك تخصيصها لموردك لمعالجتها.",
  "Shop name": "اسم المتجر",
  "Partially fulfilled": "تم إتمام جزء من الطلب",
  "Fulfillment Status": "حالة الإتمام",
  "Allocate all to vendor": "تخصيص الكل إلى المورد",
  "purchased items are delivered": "تم تسليم العناصر المشتراة",
  "Select a vendor": "اختر موردًا",
  "Product has been allocated": "تم تخصيص المنتج",
  "Vendor name / contact / shop name etc.": "اسم المورد / جهة الاتصال / اسم المتجر إلخ.",
  "Here are some other products seems can been allocated to the vendor too, do you want to do it now?": "هنا بعض المنتجات الأخرى التي قد يتم تخصيصها للمورد أيضًا، هل ترغب في فعل ذلك الآن؟",
  "Selected products": "المنتجات المحددة",
  "Allocate NOW": "تخصيص الآن",
  "No thanks": "لا شكرًا",
  "Please select at least one order": "يرجى اختيار طلب واحد على الأقل",
  "Create quotation request?": "هل ترغب في إنشاء طلب عرض أسعار؟",
  "Order ID From:": "معرف الطلب من:",
  "Order ID To:": "معرف الطلب إلى:",
  "You're going to place": "أنت على وشك وضع",
  "orders to": "الطلبات إلى",
  "responded": "تم الرد",

  "You can choose the payment method you can accept, we will submit your": "يمكنك اختيار وسيلة الدفع التي يمكنك قبولها، وسنقوم بتقديم",
  "orders and options to your vendors": "الطلبات والخيارات إلى مورديك",
  "Warm tips": "نصائح دافئة",
  "orders NOW": "الطلبات الآن",
  "Place": "وضع",
  "You have set the following products to be allocated to the vendors": "لقد قمت بتحديد المنتجات التالية لتخصيصها للموردين",
  "only once. Therefore, the following items will need to be": "مرة واحدة فقط. لذلك، ستحتاج العناصر التالية إلى",
  "re-allocated after the orders are generated again.": "إعادة تخصيصها بعد توليد الطلبات مرة أخرى.",
  "By AliExpress VIP link": "عن طريق رابط AliExpress VIP",
  "Product title": "عنوان المنتج",
  "Expected price": "السعر المتوقع",
  "Current price": "السعر الحالي",
  "Reply price": "سعر الرد",
  "Reply link": "رابط الرد",
  "published": "تم النشر",
  "My support": "طلبات دعمي",
  "You have successfully hosted the": "لقد قمت باستضافة",
  "Failure reason": "سبب الفشل",
  "Store products": "منتجات المتجر",
  "Query": "استفسار",
  "Please enter": "يرجى إدخال",
  "State": "الحالة",
  "Penging": "قيد الانتظار",
  "Add Vendor": "إضافة مورد",
  "Edit Vendor": "تعديل المورد",
  "Destination Country": "الدولة الوجهة:",
  "My sourcing products": "منتجاتي المستوردة",
  "Vendor information": "معلومات المورد",
  "Vendor Contact": "جهة اتصال المورد",
  "Bonus Balance($)": "رصيد المكافأة ($)",
  "Sales statistics": "إحصائيات المبيعات",
  "Please enter description": "يرجى إدخال الوصف",
  "Please enter IOSS ID": "يرجى إدخال معرف IOSS",
  "Please select destination country": "يرجى اختيار الدولة الوجهة",
  "Please select at least 1 destination country.": "يرجى اختيار دولة واحدة على الأقل.",
  "Please enter an IOSS ID with 12 alphanumeric characters.": "يرجى إدخال معرف IOSS يحتوي على 12 حرفًا رقميًا.",
  "After saving, your IOSS will be updated to the corresponding order. Are you sure to save?": "بعد الحفظ، سيتم تحديث IOSS الخاص بك إلى الطلب المقابل. هل أنت متأكد من الحفظ؟",
  "Settings": "الإعدادات",
  "According to the new European VAT e-commerce rules, declaration without lOSS will result in a delay in customs clearance and the recipient will be required to pay VAT, as the parcel will be detained when contact of the recipient is incorrect.": "وفقًا للقواعد الجديدة لضريبة القيمة المضافة الأوروبية للتجارة الإلكترونية، فإن التصريح بدون IOSS سيؤدي إلى تأخير في التخليص الجمركي وسيتم مطالبة المستلم بدفع ضريبة القيمة المضافة، حيث سيتم احتجاز الطرد إذا كانت بيانات الاتصال للمستلم غير صحيحة.",
  "IOSS Option": "خيار IOSS",
  "No IOSS": "لا يوجد IOSS",
  "The amount of the orders (shipping cost included) will be declared and recipients will be required by the customs to pay VAT when parcels arrive in the destination countries of EU": "سيتم إعلان مبلغ الطلبات (بما في ذلك تكلفة الشحن) وسيتعين على المستلمين دفع ضريبة القيمة المضافة عند وصول الطرود إلى دول الوجهة في الاتحاد الأوروبي",
  "Please enter correct and valid IOSS IDs, which should be linked to corresponding destination countries. IOSS ID will not be applied if the destination country is not linked to a correct IOSS ID": "يرجى إدخال معرفات IOSS صحيحة وصالحة، والتي يجب ربطها بالدول الوجهة المقابلة. لن يتم تطبيق IOSS إذا كانت الدولة الوجهة غير مرتبطة بمعرف IOSS صحيح",
  "My IOSS Settings": "إعدادات IOSS الخاصة بي",
  "Declare with my own IOSS": "إعلان باستخدام IOSS الخاص بي",
  "Linked Countries": "الدول المرتبطة",
  "Add IOS": "إضافة IOSS، هل أنت متأكد من حذف IOSS؟",
  "Unlinked Countries:": "الدول غير المرتبطة:",
  "Are you sure to delete the IOSS?": "هل أنت متأكد من حذف IOSS؟",
  "Excluding VAT amount": "المبلغ باستثناء ضريبة القيمة المضافة",
  "VAT am": "قيمة ضريبة القيمة المضافة",
  "Amount including VAT": "المبلغ شامل ضريبة القيمة المضافة",
  "AliExpress store information": "معلومات متجر AliExpress",
  "Detailed seller ratings": "تصنيفات البائع التفصيلية",
  "Recent Products": "المنتجات الأخيرة",
  "Store No.": "رقم المتجر",
  "This store has been open since": "تم فتح هذا المتجر منذ",
  "Positive feedback": "تعليقات إيجابية",
  "Business License": "رخصة تجارية",
  "Item as Described": "المنتج كما هو موصوف",
  "Above": "أعلى",
  "Below": "أدنى",
  "Average": "السعر لكل وحدة",
  "Shipping Speed": "سرعة الشحن",
  "Detailed Seller Ratings information is unavailable when there're less than 10 rating": "معلومات تصنيفات البائع التفصيلية غير متوفرة عندما يكون هناك أقل من 10 تقييمات",
  "My Vendors": "مورديّ",
  "By Vendor Name": "باسم المورد",
  "By AliExpress Url": "بـ URL من علي إكسبريس",
  "Please enter your vendor's name": "يرجى إدخال اسم المورد",
  "Vendor's Name": "اسم المورد",
  "Vendor's AliExpress shop or product URL": "URL متجر أو منتج المورد على علي إكسبريس",
  "How to get the vendor's AliExpress shop / product URL?": "كيف تحصل على URL متجر أو منتج المورد على علي إكسبريس؟",
  "Transaction Flow Line": "خط سير المعاملات",
  "Recharge Time": "وقت الشحن",
  "customer successfully edited": "تم تعديل العميل بنجاح",
  "customer successfully added": "تم إضافة العميل بنجاح",
  "Address Management": "إدارة العناوين",
  "Default Shipping Address": "عنوان الشحن الافتراضي",
  "First name": "الاسم الأول",
  "Last name": "الاسم الأخير",
  "Phone": "الهاتف",
  "Address": "العنوان",
  "City": "المدينة",
  "Postcode": "الرمز البريدي",
  "Province": "المقاطعة",
  "Country": "البلد",
  "No address": "لا يوجد عنوان",
  "Do you want to delete?": "هل تريد الحذف؟",
  "delete successfully": "تم الحذف بنجاح",
  "My Allocated Products": "منتجاتي المخصصة",
  "save successfully": "تم الحفظ بنجاح",
  "My Allocated Product": "منتجي المخصص",
  "Batch Re-allocate": "إعادة تخصيص دفعة",
  "Batch Un-allocate": "إلغاء تخصيص دفعة",
  "All my stores": "جميع متاجري",
  "UN-allocate Success": "إلغاء التخصيص بنجاح",
  "Receipt": "إيصال",
  "LOGIN": "تسجيل الدخول",
  "Privacy policy": "سياسة الخصوصية",
  "Terms of use": "شروط الاستخدام",
  "Refund Policy": "سياسة الاسترجاع",
  "FAQs": "الأسئلة الشائعة",

  "This file format is not supported": "تنسيق الملف غير مدعوم",
  "The file size can not over 2MB": "لا يمكن أن يتجاوز حجم الملف 2 ميجابايت",
  "Please input your message": "يرجى إدخال رسالتك",
  "BCNDropshipping - Easy Dropshipping": "BCNDropshipping - دروبشيبينغ سهل",
  "The question must not be empty": "يجب ألا تكون السؤال فارغًا",
  "Shopify store name": "اسم متجر Shopify",
  "Current Unit Cost": "التكلفة الحالية للوحدة",
  "Welcome to": "مرحبًا بك في",
  "Please sign in or register an account to start the chat.": "يرجى تسجيل الدخول أو تسجيل حساب لبدء المحادثة.",
  "All Items": "جميع العناصر",
  "back": "عودة",
  "Check All": "تحقق من الكل",
  "Digital Themrmometer Hygrometer Living Ro Digital Themrmometer Hygrometer Living Ro": "مقياس حرارة ورطوبة رقمي",
  "Bulk Purchase": "شراء بالجملة",
  "Do you want to delete selected items?": "هل تريد حذف العناصر المحددة؟",
  "Hi, welcome to": "مرحبًا، أهلاً بك في",
  "Welcome to ()! Please sign in or register an account to": "مرحبًا بك في ()! يرجى تسجيل الدخول أو إنشاء حساب ل",
  "start the chat.": "بدء المحادثة.",
  "Register": "تسجيل",
  "Recall": "استرجاع",
  "Trade name": "اسم النشاط التجاري",
  "Purchase price:": "سعر الشراء:",
  "Start date": "تاريخ البدء",
  "End date": "تاريخ الانتهاء",
  "Expected Price": "السعر المتوقع",
  "Product link": "رابط المنتج",
  "Product note": "ملحوظة",
  "Screenshot": "لقطة شاشة",
  "Dispatched Items": "العناصر التي تم شحنها",
  "Valid Invoices": "فواتير صالحة",
  "Valid Amount Due": "المبلغ المستحق الصالح",
  "Order items that you can dispatch to vendors": "عناصر الطلب التي يمكنك شحنها إلى البائعين",
  "No Picture": "لا توجد صورة",
  "Dispatch order's items to vendors": "شحن عناصر الطلب إلى البائعين",
  "You can modify your order dispatch rules at any time in the menu 'MyOrders >> Dispatch settings'": "يمكنك تعديل قواعد شحن الطلبات في أي وقت من القائمة 'طلباتي >> إعدادات الشحن'",
  "Dispatch to": "الشحن إلى",
  "vendor(s)": "البائع (البائعين)",
  "Complete personal information": "إكمال المعلومات الشخصية",
  "Start pulling orders": "بدء سحب الطلبات",
  "Please select the vendor": "يرجى اختيار البائع",
  "Please select the circle period": "يرجى اختيار فترة الدائرة",
  "Are you sure you want to cancel it?": "هل أنت متأكد أنك تريد إلغاءه؟",
  "Disputed order": "طلب متنازع عليه",
  "Awaiting Response": "بانتظار الرد",
  "Search": "بحث",
  "Tracking Number": "رقم التتبع",
  "Dispute Type": "نوع النزاع",
  "Expected Solution": "الحل المتوقع",
  "Last week": "الأسبوع الماضي",
  "Last month": "الشهر الماضي",
  "OK": "حسنًا",
  "Type": "النوع",
  "Last three months": "آخر ثلاثة أشهر",
  "The page you are looking for can't be found.": "الصفحة التي تبحث عنها غير موجودة.",
  "BACK TO HOMEPAGE": "الرجوع إلى الصفحة الرئيسية",
  "Transform Your eCommerce business Into a Powerhouse": "حوّل عملك في التجارة الإلكترونية إلى قوة عظمى",
  "Importify helps people like you to automate their dropshipping business.": "يساعد Importify الأشخاص مثلك على أتمتة عملهم في الدروبشيبينغ.",
  "Product Research": "بحث عن المنتجات",
  "Are you tired of searching the millions of products on AliExpress for potential winners?": "هل سئمت من البحث في ملايين المنتجات على AliExpress للعثور على الفائزين المحتملين؟",
  "One-click import products": "استيراد المنتجات بنقرة واحدة",
  "Profit": "الربح",
  "Import products from 30+ top dropshipping vendors, Aliexpress, Alibaba, Amazon, Etsy, Dhgate, Lazada, Shopee, Banggood, Taobao, 1688, Gearbest, Walmart, and many more.": "استيراد المنتجات من أكثر من 30 بائع دروبشيبينغ رئيسي مثل Aliexpress، Alibaba، Amazon، Etsy، Dhgate، Lazada، Shopee، Banggood، Taobao، 1688، Gearbest، Walmart وغيرهم.",
  "Pricing Rules": "قواعد التسعير",
  "Tired of calculating your target profit margin? Create pricing rules before importing, quickly adjust prices for sales.": "هل سئمت من حساب هامش الربح المستهدف؟ أنشئ قواعد التسعير قبل الاستيراد، وقم بتعديل الأسعار بسرعة للخصومات.",
  "Product Customization": "تخصيص المنتجات",
  "Use our chrome extension to modify the title, description, images, variants, pricing of the imported products.": "استخدم ملحق كروم الخاص بنا لتعديل العنوان، والوصف، والصور، والأنواع، والأسعار للمنتجات المستوردة.",
  "Automate your orders": "أتمتة طلباتك",
  "The Importify Chrome Extension allows you to fulfill your orders quickly by placing the customer address automatically on the checkout page.": "يتيح لك ملحق Importify كروم إتمام طلباتك بسرعة عن طريق وضع عنوان العميل تلقائيًا على صفحة الدفع.",
  "Easy vendor Change": "تغيير البائع بسهولة",
  "Replace your product vendor with a new vendor and connect them to your store with a click.": "استبدل بائع منتجك ببائع جديد ووصله إلى متجرك بنقرة واحدة.",
  "Auto Dispatch Collections": "تجميع الشحن التلقائي",
  "Auto-dispatch products to your Store collections supported on Shopify, WooCommerce, and Jumpseller.": "تجميع الشحن التلقائي للمنتجات في مجموعات متجرك المدعومة من Shopify و WooCommerce و Jumpseller.",
  "Split Variants": "تقسيم الأنواع",
  "Variants": "الأنواع",
  "Importify gives you the ability to Split variants into Separate products.": "يوفر لك Importify القدرة على تقسيم الأنواع إلى منتجات منفصلة.",
  "Connect Existing Products": "اتصل بالمنتجات الحالية",
  "If you have products that are already on a Shopify, WooCommerce or Jumpseller store, you can connect and manage them in Importify.": "إذا كانت لديك منتجات بالفعل على متجر Shopify أو WooCommerce أو Jumpseller، يمكنك ربطها وإدارتها في Importify.",
  "Add to Import List": "إضافة إلى قائمة الاستيراد",
  "View More": "عرض المزيد",
  "MORE": "المزيد",
  "Categories": "الفئات",
  "Tag": "التصنيف",
  "Returnable with in": "قابل للإرجاع خلال",
  "No Account?": "لا حساب؟",
  "Find Products": "ابحث عن منتجات",
  "My Import List": "قائمة استيرادي",
  "Please select a shipping address": "يرجى اختيار عنوان الشحن",
  "Please select a shipping method": "يرجى اختيار طريقة الشحن",
  "How to find products? Find products in": "كيف تجد المنتجات؟ ابحث عن المنتجات في",
  "Products Market! Dropshipping from Worldwide to Worldwide!": "سوق المنتجات! دروبشيبينغ من جميع أنحاء العالم إلى جميع أنحاء العالم!",
  "Email must be filled in": "يجب تعبئة البريد الإلكتروني",
  "CAPTCHA must be filled in": "يجب تعبئة CAPTCHA",
  "New password must be filled in": "يجب تعبئة كلمة المرور الجديدة",
  "The new password and confirm password must be the same": "يجب أن تكون كلمة المرور الجديدة وكلمة المرور المؤكدة متطابقتين",
  "The password must contain letters, and numbers, Minimum 8 characters": "يجب أن تحتوي كلمة المرور على حروف وأرقام، الحد الأدنى 8 أحرف",
  "Password reset successful": "تم إعادة تعيين كلمة المرور بنجاح",
  "Password must be filled in": "يجب تعبئة كلمة المرور",
  "IN ALL CATEGORIES": "في جميع الفئات",
  "Request Quotation": "طلب عرض سعر",
  "More categories": "مزيد من الفئات",
  "Place Order": "قم بتقديم الطلب",
  "Choose orders": "اختر الطلبات",
  "Manage-Addresses": "إدارة العناوين",
  "Default Address": "العنوان الافتراضي",
  "There is no Shipping method to reach the current address": "لا توجد طريقة شحن للوصول إلى العنوان الحالي",
  "Please select address": "يرجى اختيار العنوان",
  "Product Price": "سعر المنتج",
  "Choose the products from your Shopify orders to allocated to your vendor": "اختر المنتجات من طلباتك على Shopify لتخصيصها للبائع",
  "Click the Allocate to vendor button on the bottom of the page.": "انقر على زر تخصيص للبائع في أسفل الصفحة.",
  "Tips: You can filter your orders here.": "نصائح: يمكنك تصفية طلباتك هنا.",
  "Choose or create a new vendor.": "اختر أو أنشئ بائعًا جديدًا.",
  "Click the Allocate button of the page,you can also allocate items from the same SPU to the same vendor": "انقر على زر تخصيص الصفحة، يمكنك أيضًا تخصيص العناصر من نفس SPU للبائع نفسه.",
  "Un-allocate selected products": "إلغاء تخصيص المنتجات المحددة",
  "Total vendors": "إجمالي البائعين",
  "Total orders": "إجمالي الطلبات",
  "Click the": "انقر على",
  "Allocate to vendor": "تخصيص للبائع",
  "button on the bottom of the page.": "الزر في أسفل الصفحة.",
  "Total Product": "إجمالي المنتجات",
  "Previous": "السابق",
  "Next": "التالي",
  "and Automate": "وأتمتة",
  "your entire dropshipping process": "عملية الدروبشيبينغ بالكامل",
  "Place 1 purchase orders": "تقديم طلب شراء واحد",
  "With just one click, you can easily allocate your stores orders to your vendors and the entire shipping process will be automatically completed.": "بنقرة واحدة فقط، يمكنك تخصيص طلبات متجرك للبائعين، وسيتم إتمام عملية الشحن بالكامل تلقائيًا.",
  "Create a purchase orders to your vendor.": "أنشئ طلب شراء للبائع.",
  "Choose the Shopify orders you want to sourcing,and click the Make a purchase order button of the page.": "اختر طلبات Shopify التي تريد مصدرها، وانقر على زر إنشاء طلب شراء في الصفحة.",
  "After confirming the operation,The purchase orders will be created successfully.": "بعد تأكيد العملية، سيتم إنشاء طلبات الشراء بنجاح.",
  "Share purchase orders URL to your vendor and wait your vendor finish the invoice for you.": "شارك رابط طلبات الشراء مع البائع وانتظر حتى ينتهي البائع من إعداد الفاتورة لك.",
  "Click the <b>Invite vendor to process</b> button on the bottom of the page.": "انقر على زر <b>دعوة البائع لمعالجة</b> في أسفل الصفحة.",
  "You can send the purchase orders by Skype, WeChat or share by URL link.": "يمكنك إرسال طلبات الشراء عبر Skype أو WeChat أو مشاركتها عبر رابط URL.",
  "I have finished the payment": "لقد أنهيت الدفع",
  "<b>Invite vendor to process</b>": "<b>دعوة البائع للمعالجة</b>",
  "Items total": "إجمالي العناصر",

  "Remove success": "تم الحذف بنجاح",
  "Track number must be entered": "يجب إدخال رقم التتبع",
  "Track company must be entered": "يجب إدخال شركة التتبع",
  "Track company  must be entered": "يجب إدخال شركة التتبع",
  "Track Url must be entered": "يجب إدخال عنوان URL للتتبع",
  "Please enter Shopify store URL": "يرجى إدخال رابط متجر Shopify",
  "Under authorization,please wait...": "تحت الإذن، يرجى الانتظار...",
  "Have you finished the payment": "هل أكملت الدفع؟",
  "At least one field must be selected": "يجب تحديد حقل واحد على الأقل",
  "The name of the customized header cannot be empty": "اسم الرأس المخصص لا يمكن أن يكون فارغًا",
  "Export the order information": "تصدير معلومات الطلب",
  "Simple, Transparent Pricing": "أسعار بسيطة وشفافة",
  "Importify offers three types of plans; Basic plan, Premium plan, and Gold plan.": "تقدم Importify ثلاث خطط: الخطة الأساسية، الخطة المميزة، والخطة الذهبية.",
  "Each account starts with a day trial, and your billing cycle begins after the free trial period has ended.": "يبدأ كل حساب مع تجربة لمدة يوم، ويبدأ دورة الفوترة بعد انتهاء فترة التجربة المجانية.",
  "Importify Plans<": "خطط Importify<",
  "Basics": "أساسي",
  "Premium": "مميز",
  "Gold": "ذهبي",
  "Offers": "عروض",
  "Amazon & Aliexpress importer": "مستورد أمازون و علي إكسبريس",
  "Semi-automatic order fulfillment (Supported on Aliexpress, Amazon, Dhgate & Wonify)": "إتمام الطلبات شبه التلقائي (مدعوم على علي إكسبريس، أمازون، Dhgate وWonify)",
  "Product Customisation": "تخصيص المنتج",
  "Update Product": "تحديث المنتج",
  "Shipping Time": "وقت الشحن",
  "After Sales Service": "خدمة ما بعد البيع",
  "product description": "وصف المنتج",
  "Store price": "سعر المتجر",
  "Delivery:   Varies for items shipped from an international location": "التوصيل: يختلف للمنتجات المشحونة من موقع دولي",
  "This product has been removed from the shelves": "تم إزالة هذا المنتج من الرفوف",
  "Return": "إرجاع",
  "Enter Store name": "أدخل اسم المتجر",
  "Enter vendor name": "أدخل اسم البائع",
  "Allow Customer Services from ": "السماح لخدمات العملاء من ",
  "Purchase List": "قائمة الشراء",
  "Complete your Skype or WhatsApp details to get rewards": "أكمل تفاصيل سكايب أو واتساب للحصول على المكافآت",
  "You have completed the Skype or WhatsApp, you can receive a free gift package.": "لقد أكملت تفاصيل سكايب أو واتساب، يمكنك استلام حزمة هدايا مجانية.",
  "The captcha was sent successfully": "تم إرسال رمز التحقق بنجاح",
  "Order Details": "تفاصيل الطلب",
  "Sub Order NO": "رقم الطلب الفرعي",
  "Product Information": "معلومات المنتج",
  "Sub Total": "المجموع الفرعي",
  "Grand Total": "المجموع الكلي",
  "Tracking Number:": "رقم التتبع:",
  "Total Amount": "المبلغ الإجمالي",
  "Products Cost": "تكلفة المنتجات",
  "Enter SKU": "أدخل SKU",
  "Package": "الطرد",
  "I agree the": "أوافق على",
  "Pay NOW": "ادفع الآن",
  "All vendors": "جميع البائعين",
  "Dispatch Status": "حالة الإرسال",
  "You could select multiple vendors": "يمكنك اختيار عدة بائعين",
  "Shipping Cost Included": "شحن مجاني مشمول",
  "Do you want to cancel the order?": "هل تريد إلغاء الطلب؟",
  "Order was successfully cancelled": "تم إلغاء الطلب بنجاح",
  "Choose your recharge package": "اختر حزمة الشحن الخاصة بك",
  "Choose your payment method": "اختر طريقة الدفع",
  "Payment Record": "سجل الدفع",
  "Platform Reply": "رد المنصة",
  "Picture": "صورة",
  "Product Title": "عنوان المنتج:",
  "Price Range": "نطاق السعر:",
  "Base Information": "المعلومات الأساسية",
  "Product Links": "روابط المنتجات:",
  "Product Description": "وصف المنتج:",
  "Trade Name": "اسم التجارة",
  "Only matching last": "فقط آخر متطابق",
  "Save Rule": "حفظ القاعدة",
  "Please select the Period": "يرجى تحديد الفترة",
  "Please select the vendor visibility": "يرجى تحديد رؤية البائع",
  "Automatic dispatch orders setting": "إعداد إرسال الطلبات تلقائيًا",
  "Show hidden orders": "إظهار الطلبات المخفية",
  "Choose my all Shopify products": "اختر جميع منتجاتي على Shopify",
  "shopify orders have been selected and can now be dispatched to your vendors": "تم اختيار طلبات Shopify ويمكن الآن إرسالها إلى بائعيك",
  "Dispatch to the vendor": "إرسال إلى البائع",
  "My all Shopify products": "جميع منتجاتي على Shopify",
  "days unfulfilled orders": "أيام الطلبات غير المنفذة",
  "Dispatch rule TEST": "قاعدة الإرسال TEST",
  "THE BRIDGE CONNECTING SUPPLIERS AND YOU, MAKING DROPSHIPPING BUSINESS MORE CONVENIENT": "الجسر الذي يربط الموردين بك، مما يجعل عمل الدروبشيبينغ أكثر راحة",
  "Your supplier only needs to register an account to quickly build the system": "كل ما يحتاجه المورد الخاص بك هو تسجيل حساب لبناء النظام بسرعة",
  "One-click hosting of stores, fast synchronization of orders": "استضافة المتاجر بنقرة واحدة، ومزامنة الطلبات بسرعة",
  "Automatically synchronize logistics information": "مزامنة معلومات اللوجستيات تلقائيًا",
  "Quick Access": "الوصول السريع",
  "Do you have an BCN supplier for you": "هل لديك مورد BCN لك؟",
  "Already have a supplier": "لديك مورد بالفعل",
  "I don't have a supplier": "لا أملك موردًا",
  "Let your supplier fulfill your order more systematically, copy the link and send it to your supplier, and immediately invite your supplier to settle in,": "دع موردك ينفذ طلبك بشكل أكثر تنظيمًا، انسخ الرابط وأرسله إلى موردك، وادعُه لتسوية حسابه فورًا",
  "2024-2024BCN All Rights Reserved": "جميع الحقوق محفوظة لـ 2024-2024BCN",
  "Waiting for the payment result to be returned": "انتظار استلام نتيجة الدفع",
  "Sorry, we can't complete the payment": "عذرًا، لا يمكننا إتمام الدفع",
  "Please check the purchase products": "يرجى التحقق من المنتجات المشتراة",
  "After the combination payment is enabled, the account balance will be deducted first, and the rest will be paid by other selected methods": "بعد تمكين الدفع المشترك، سيتم خصم رصيد الحساب أولاً، والباقي سيتم دفعه من خلال طرق أخرى مختارة",
  "Please select the goods first!": "يرجى اختيار السلع أولاً!",
  "Please choose the logistics channel": "يرجى اختيار قناة الشحن",

  "请输入": "يرجى الإدخال",
  "工单号": "رقم التذكرة",
  "同意": "موافق",
  "已确认": "تم التأكيد",
  "售后工单": "تذكرة ما بعد البيع",
  "工单类型": "نوع التذكرة",
  "客户名称": "اسم العميل",
  "审批": "الموافقة",
  "交易类型": "نوع المعاملة",
  "问题类型": "نوع المشكلة",
  "问题描述": "وصف المشكلة",
  "退款": "استرداد",
  "更换": "استبدال",
  "修改客户相关信息": "تعديل المعلومات المتعلقة بالعميل",
  "取消订单": "إلغاء الطلب",
  "无跟踪信息": "لا توجد معلومات تتبع",
  "跟踪信息长时间未更新": "لم يتم تحديث معلومات التتبع لفترة طويلة",
  "物品损坏": "تلف المنتج",
  "物品丢失": "فقدان المنتج",
  "发送错误产品": "إرسال منتج خاطئ",
  "发送错误地址": "إرسال عنوان خاطئ",
  "订单暂停": "طلب معلق",
  "选填": "اختياري",
  "订单信息": "معلومات الطلب",
  "第三方订单编号": "رقم الطلب من طرف ثالث",
  "订单编号": "رقم الطلب",
  "店铺": "المتاجر",
  "创建时间": "وقت الإنشاء",
  "开泰银行支付": "دفع عبر بنك كايتير",
  "供应商已发货，但物流信息未同步到Shopify店铺": "قام المورد بالشحن، ولكن لم تتم مزامنة معلومات اللوجستيات مع متجر Shopify.",
  "供应商已发货，物流信息已同步到Shopify店铺": "قام المورد بالشحن، وتمت مزامنة معلومات اللوجستيات مع متجر Shopify.",
  "您还没有选择可导出的字段。请在下方选择。": "لم تقم بعد باختيار الحقول التي يمكن تصديرها. يرجى الاختيار أدناه.",
  "采购订单基础信息": "معلومات أساسية عن طلب الشراء",
  "订单总数": "إجمالي عدد الطلبات",
  "订单商品项": "عناصر طلب المنتج",
  "合计商品总数": "إجمالي عدد المنتجات",
  "合计采购金额": "إجمالي مبلغ الشراء",
  "发货情况统计": "إحصاءات الشحن",
  "已发货商品数": "عدد المنتجات المشحونة",
  "已发货商品额": "قيمة المنتجات المشحونة",
  "未发货商品数": "عدد المنتجات غير المشحونة",
  "未发货商品额": "قيمة المنتجات غير المشحونة",
  "发货率": "معدل الشحن",
  "不发货商品数": "عدد المنتجات غير المشحونة",
  "不发货商品额": "قيمة المنتجات غير المشحونة",
  "当前发票页面仅供预览，如果发送给客户请使用发票编辑页面的'发送发票'功能！": "صفحة الفاتورة الحالية هي للمعاينة فقط، إذا كنت سترسلها للعميل، يرجى استخدام وظيفة 'إرسال الفاتورة' في صفحة تحرير الفاتورة.",
  "发票预览": "معاينة الفاتورة",
  "如图一所示:页面顶部“发送发票”按钮": "كما هو موضح في الشكل 1: زر 'إرسال الفاتورة' في أعلى الصفحة",
  "如图二所示:页面底部'发送发票'按钮": "كما هو موضح في الشكل 2: زر 'إرسال الفاتورة' في أسفل الصفحة",
  "商品列表页": "صفحة قائمة المنتجات",
  "底部": "أسفل",
  "顶部": "أعلى",
  "请输入单号范围": "يرجى إدخال نطاق رقم الطلب",
  "起始单号必须小于结束单号": "يجب أن يكون رقم الطلب الابتدائي أقل من رقم الطلب النهائي",
  "确定删除该商品？": "هل أنت متأكد من حذف هذا المنتج؟",
  "确定": "موافق",
  "取消": "إلغاء",
  "已取消": "تم الإلغاء",
  "选取文件": "اختيار ملف",
  "点击下载": "اضغط للتنزيل",
  "订单导入模板": "قالب استيراد الطلبات",
  "请按规范填写表格，仅支持xlsx格式文件": "يرجى ملء النموذج وفقًا للمعايير، فقط ملفات بصيغة xlsx مدعومة",
  "上传的文件不能超过2M，只处理前99条数据": "لا يمكن أن يتجاوز حجم الملف المحمّل 2 ميجابايت، ويتم معالجة أول 99 بيانات فقط",
  "待审核": "قيد المراجعة",
  "通过": "تم الموافقة",
  "拒绝": "تم الرفض",
  "申诉": "استئناف",
  "余额": "الرصيد",
  "线下": "خارج الخط",
  "提现方式": "طريقة السحب",
  "状态": "حالة الموافقة",
  "警告提示": "تحذير",
  "该分类下目前还没有商品": "لا توجد منتجات حاليًا في هذه الفئة",
  "最大建议尺寸 200px * 200px, 图片可自适应": "الحجم الموصى به 200 بكسل * 200 بكسل، يمكن للصورة التكيف",
  "添加图片": "إضافة صورة",
  "更改": "تغيير",
  "删除": "حذف",
  "请联系供应商，完善站长外部编号": "يرجى الاتصال بالمورد لإتمام الرقم الخارجي للمشرف",
  "返回": "رجوع",
  "上传图片大小不能超过 500kb!": "لا يجب أن يتجاوز حجم الصورة المحملة 500 كيلوبايت!",
  "描述文字": "نص الوصف",
  "履行费用": "رسوم التنفيذ",
  "发货时效": "زمن الشحن",

  "Pause": "إيقاف مؤقت",
  "productType": "نوع المنتج",
  "platform": "المنصة",
  "Operation": "عملية",
  "Open in website": "افتح في الموقع",
  "Edit on Dashboard": "تحرير على لوحة المعلومات",
  "Split orders": "تقسيم الطلبات",
  "Reply date": "تاريخ الرد",
  "null Please make an offer": "فارغ، يرجى تقديم عرض",
  "Yes": "نعم",
  "No": "لا",
  "Are you sure?": "هل أنت متأكد؟",
  "After-sales Service": "خدمة ما بعد البيع",
  "Deal Type": "نوع الصفقة",
  "Damaged Item": "منتج تالف",
  "Wrong product": "منتج خاطئ",
  "The client received the order?": "هل استلم العميل الطلب؟",
  "Whats happend?": "ماذا حدث؟",
  "Please select type first.": "يرجى تحديد النوع أولاً.",
  "You can modify your order dispatch rules at any time in the menu 'My Orders >> Dispatch settings'": "يمكنك تعديل قواعد إرسال الطلبات في أي وقت من خلال القائمة 'طلباتي >> إعدادات الإرسال'",
  "Comexbcn Privacy Statement": "بيان خصوصية Comexbcn",
  "How Comexbcn Uses Your Data": "كيف تستخدم Comexbcn بياناتك",
  "This statement demonstrates how seriously and responsibly we handle user privacy.": "يُظهر هذا البيان كيف نتعامل مع خصوصية المستخدم بجدية ومسؤولية.",
  "It details to the user how our company, COMEXBCN, collects, handles, shares, and processes their data and/or information.": "يشرح هذا للمستخدم كيفية جمع شركتنا COMEXBCN للبيانات والمعلومات الخاصة بهم، معالجتها، ومشاركتها.",
  "This page alerts and informs the user that by choosing our service and app/website,": "تُنبّه هذه الصفحة المستخدم وتعلمه أنه باختيار خدمتنا وتطبيقنا/موقعنا الإلكتروني،",
  "they agree to the use, collection, and processing of dropshipping by Comexbcn,": "يوافقون على استخدام وجمع ومعالجة الدروب شيبنج بواسطة Comexbcn،",
  "and also that they accept all the “TERMS AND CONDITIONS”.": "وأيضًا أنهم يقبلون جميع “الشروط والأحكام”.",
  "Any personal information may be used to help improve our app/website.": "يمكن استخدام أي معلومات شخصية للمساعدة في تحسين تطبيقنا/موقعنا الإلكتروني.",
  "Collection and Use of Information": "جمع واستخدام المعلومات",
  "If you use our app/website, we may request that you provide personal identification data.": "إذا استخدمت تطبيقنا/موقعنا الإلكتروني، قد نطلب منك تقديم بيانات تعريف شخصية.",
  "This is not limited to the name for full use of our app/website's functions.": "لا يقتصر ذلك على الاسم لاستخدام كامل وظائف تطبيقنا/موقعنا الإلكتروني.",
  "We also intend to use the data for “marketing activities” and for conducting general research and evaluations.": "نعتزم أيضًا استخدام البيانات في “الأنشطة التسويقية” وإجراء الأبحاث والتقييمات العامة.",
  "Values": "القيم",
  "Recognition of the nature of our business and your information": "التعرف على طبيعة عملنا ومعلوماتك",
  "We perform a legally authorized service to provide services.": "نؤدي خدمة مرخصة قانونيًا لتوفير الخدمات.",
  "Our commitment is to integrity, transparency, and respect for privacy in all aspects.": "إلتزامنا هو بالنزاهة والشفافية واحترام الخصوصية في جميع الجوانب.",
  "We will process and use only essential information for our business,": "سنقوم بمعالجة واستخدام المعلومات الأساسية فقط لأعمالنا،",
  "with personal data belonging solely and exclusively to the user,": "مع العلم أن البيانات الشخصية تعود فقط وحصريًا للمستخدم،",
  "thus respecting its nature and treating it sensitively in every detail.": "مما يضمن احترام طبيعتها والتعامل معها بحساسية في كل التفاصيل.",
  "Protecting Your Information": "حماية معلوماتك",
  "For any third-party requests requiring your information,": "لأي طلبات من أطراف ثالثة تطلب معلوماتك،",
  "our company will only provide it with the user’s consent,": "ستقدم شركتنا هذه المعلومات فقط بموافقة المستخدم،",
  "without any sharing with external sources,": "دون أي مشاركة مع مصادر خارجية،",
  "unless obligated to comply with applicable laws and regulations,": "إلا إذا كان هناك التزام بالامتثال للقوانين واللوائح المعمول بها،",
  "responding to an official subpoena, or any other judicial request,": "استجابة للمذكرة القانونية الرسمية، أو أي طلب قضائي آخر،",
  "seeking to protect our user and also our rights.": "في محاولة لحماية مستخدمينا وأيضًا حقوقنا.",
  "Usability Rights": "حقوق الاستخدام",
  "Comexbcn is focused on prevention, striving to avoid errors in its procedures as much as possible. However, if there is any situation where a cancellation and return are desired, our policy for taking appropriate actions is described below.": "تركز Comexbcn على الوقاية، مع السعي لتجنب الأخطاء في إجراءاتها قدر الإمكان. ومع ذلك، إذا كانت هناك أي حالة حيث يرغب المستخدم في إلغاء وإرجاع المنتج، فإن سياستنا في اتخاذ الإجراءات المناسبة موضحة أدناه.",
  "Cancellation": "الإلغاء",
  "We accept cancellation requests before the product is shipped or produced. In this case, a full refund will be issued. If the product has already been shipped, it cannot be canceled.": "نقبل طلبات الإلغاء قبل شحن أو إنتاج المنتج. في هذه الحالة، سيتم إصدار استرداد كامل. إذا تم شحن المنتج بالفعل، فلا يمكن إلغاؤه.",
  "Returns": "الإرجاع",
  "Respecting the consumer's right to request a return within 10 days after the product's delivery, we accept returns under the condition that the item or items are not in use and are in their original delivery packaging. Our customer service department will request the receipt or proof of purchase to certify the procedure so that the shipment can be made to the correct address.": "احترامًا لحق المستهلك في طلب الإرجاع خلال 10 أيام بعد تسليم المنتج، نقبل الإرجاع بشرط أن المنتج أو المنتجات غير مستخدمة وفي عبوتها الأصلية. ستطلب خدمة العملاء لدينا الإيصال أو إثبات الشراء لتوثيق الإجراء ليتم إرسال الشحنة إلى العنوان الصحيح.",
  "Items that are damaged or lost qualify for a full refund, or another item of the same order can be sent under the same conditions, or the corresponding value of the claimed item can be refunded.": "المنتجات التالفة أو المفقودة مؤهلة للحصول على استرداد كامل، أو يمكن إرسال منتج آخر من نفس الطلب بنفس الشروط، أو يمكن استرداد القيمة المقابلة للمنتج المطالب به.",
  "Refund Process": "عملية الاسترداد",
  "After receiving the item and performing the check as indicated above, we will notify you of the receipt and the processing time for the refund. A credit of the agreed amount will be issued as agreed between the parties via email, indicating the time frame to complete the process.": "بعد استلام المنتج وإجراء الفحص كما هو موضح أعلاه، سنخطرك بالاستلام ووقت معالجة الاسترداد. سيتم إصدار رصيد بالمبلغ المتفق عليه كما هو متفق بين الطرفين عبر البريد الإلكتروني، مع تحديد الإطار الزمني لإتمام العملية.",
  "For any clarifications, please contact our support at: contato@comexbcn.com with your contact information, indicating the purchased item.": "لأي استفسارات، يرجى الاتصال بدعمنا عبر: contato@comexbcn.com مع معلومات الاتصال الخاصة بك، مع تحديد المنتج المشتراة.",

  "This application/site is managed by the Comexbcn team. They are responsible for all management, and whenever we use the words \"we,\" \"together,\" and \"our,\" they refer to this team at app.comexbcn.com, including tools, information, and services. Any user who accesses our site and application is conditioned to accept our terms and conditions of use, company policies, and notices mentioned here.": "هذا التطبيق/الموقع يتم إدارته من قبل فريق Comexbcn. وهم المسؤولون عن جميع إدارة الموقع، وعندما نستخدم كلمات \"نحن\"، \"معاً\"، و\"خاصتنا\"، فإنها تشير إلى هذا الفريق في app.comexbcn.com، بما في ذلك الأدوات والمعلومات والخدمات. أي مستخدم يقوم بالوصول إلى موقعنا وتطبيقنا يجب عليه قبول شروط وأحكام الاستخدام، والسياسات والإشعارات المذكورة هنا.",

  "By visiting our application and/or site, purchasing on our platform, you declare that you are engaging in our \"Service\" and agree to comply with our following terms and conditions of use (\"TERMS AND CONDITIONS OF USE\"), including additional terms, conditions, and policies referenced here or available via link. These TERMS AND CONDITIONS OF USE apply to users in their entirety on the site or application, without limitation, users who browse, suppliers, customers, merchants, and/or content collaborators.": "بزيارة تطبيقنا و/أو موقعنا، وشراءك على منصتنا، فإنك تُعلن أنك تشارك في \"الخدمة\" الخاصة بنا وتوافق على الامتثال لشروط وأحكام الاستخدام التالية (\"شروط وأحكام الاستخدام\"), بما في ذلك الشروط الإضافية والسياسات المذكورة هنا أو المتاحة عبر الرابط. تنطبق هذه الشروط والأحكام على جميع المستخدمين على الموقع أو التطبيق، دون أي استثناء، بما في ذلك المستخدمين الذين يتصفحون، والموردين، والعملاء، والتجار، و/أو المتعاونين في المحتوى.",

  "Please read our TERMS AND CONDITIONS OF USE carefully before accessing or using our site/application. By accessing any content on our site/application, you agree to comply with these TERMS AND CONDITIONS OF USE. If you do not agree with our terms and conditions, you may not access our site/application or use any of our services. If these TERMS AND CONDITIONS OF USE are considered an offer, their acceptance is expressly limited to these TERMS AND CONDITIONS.": "يرجى قراءة شروط وأحكام الاستخدام بعناية قبل الوصول إلى موقعنا/تطبيقنا أو استخدامه. من خلال الوصول إلى أي محتوى على موقعنا/تطبيقنا، فإنك توافق على الامتثال لهذه الشروط والأحكام. إذا كنت لا توافق على الشروط والأحكام الخاصة بنا، فلا يحق لك الوصول إلى موقعنا/تطبيقنا أو استخدام أي من خدماتنا. إذا كانت هذه الشروط والأحكام تُعتبر عرضًا، فإن قبولها يكون مقتصرًا بشكل صريح على هذه الشروط والأحكام.",

  "Any new feature or tool that is added will also be subject to our terms and conditions. The most recent version of this will always be available on this page. Comexbcn reserves the right to update, delete, or modify any part of the TERMS AND CONDITIONS OF USE by posting updates on our site/application. It is the user's responsibility to check this page to monitor our updates. Your access and use of our site/application constitute your acceptance of these changes.": "أي ميزة أو أداة جديدة تتم إضافتها ستكون خاضعة أيضًا لشروط وأحكام الاستخدام الخاصة بنا. النسخة الأحدث من هذه الشروط ستكون دائمًا متاحة على هذه الصفحة. يحتفظ Comexbcn بحق تعديل أو حذف أو تعديل أي جزء من شروط وأحكام الاستخدام من خلال نشر التحديثات على موقعنا/تطبيقنا. المسؤولية تقع على عاتق المستخدم للتحقق من هذه الصفحة لمتابعة التحديثات. وصولك واستخدامك لموقعنا/تطبيقنا يشكل قبولك لهذه التغييرات.",

  "SECTION 1 – APPLICATION/SITE TERMS OF USE": "القسم 1 – شروط الاستخدام للتطبيق/الموقع",

  "By agreeing to these TERMS AND CONDITIONS, you may not use the products advertised on the application/site for any illegal or unauthorized purpose, nor may you, under any circumstances, violate any laws in your jurisdiction (including but not limited to copyright laws).": "بموافقتك على هذه الشروط والأحكام، لا يجوز لك استخدام المنتجات المعلنة على التطبيق/الموقع لأي غرض غير قانوني أو غير مصرح به، كما لا يجوز لك في أي حال من الأحوال انتهاك أي قوانين في اختصاصك القضائي (بما في ذلك قوانين حقوق الطبع والنشر، على سبيل المثال لا الحصر).",

  "You must not transmit any worms or viruses or any code of a destructive nature. Violation of any of the Terms will result in the immediate termination of your Services.": "يجب عليك عدم نقل أي ديدان أو فيروسات أو أي كود ذي طبيعة مدمرة. سيؤدي انتهاك أي من الشروط إلى إنهاء خدماتك على الفور.",

  "SECTION 2 – GENERAL CONDITIONS": "القسم 2 – الشروط العامة",

  "We reserve the right to refuse service to anyone for any reason at any time. You understand that your content (excluding credit card information) may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit card information is always encrypted during transfer over networks.": "نحتفظ بالحق في رفض الخدمة لأي شخص في أي وقت ولأي سبب. أنت تفهم أن محتواك (باستثناء معلومات بطاقة الائتمان) قد يتم نقله بشكل غير مشفر وقد يشمل (أ) النقل عبر شبكات مختلفة؛ و (ب) التغييرات لتتوافق مع المتطلبات التقنية لشبكات أو أجهزة الاتصال. معلومات بطاقة الائتمان مشفرة دائمًا أثناء النقل عبر الشبكات.",

  "You agree not to reproduce, duplicate, copy, sell, resell, or exploit any part of the Service, use of the Service, or access to the Service or any contact on the site/application through which the service is provided, without express written permission from us.": "توافق على عدم إعادة إنتاج أو تكرار أو نسخ أو بيع أو إعادة بيع أو استغلال أي جزء من الخدمة، أو استخدام الخدمة، أو الوصول إلى الخدمة أو أي اتصال على الموقع/التطبيق الذي يتم من خلاله تقديم الخدمة، دون إذن كتابي صريح منا.",

  "The headings used in this agreement are included for convenience only and will not limit or otherwise affect these Terms.": "تم تضمين العناوين المستخدمة في هذه الاتفاقية للتسهيل فقط ولن تحد أو تؤثر على هذه الشروط.",

  "SECTION 3 – ACCURACY AND COMPLETENESS OF INFORMATION": "القسم 3 – دقة واكتمال المعلومات",

  "We are not responsible if the information provided here is not accurate, complete, or current. All material provided is for general information purposes only and should not be relied upon for making decisions without consulting primary information sources. Any reliance on the content provided is at your own risk.": "نحن غير مسؤولين إذا كانت المعلومات المقدمة هنا غير دقيقة أو كاملة أو محدثة. جميع المواد المقدمة هي لأغراض المعلومات العامة فقط ولا ينبغي الاعتماد عليها في اتخاذ القرارات دون الرجوع إلى المصادر الأصلية للمعلومات. أي اعتماد على المحتوى المقدم هو على مسؤوليتك الخاصة.",

  "This site may contain historical information, which is provided for your reference. We reserve the right to modify any document or information on this application/site at any time, without obligation to update any information on this page, and you agree that it is your responsibility to monitor any changes.": "قد يحتوي هذا الموقع على معلومات تاريخية، التي يتم توفيرها للرجوع إليها. نحتفظ بالحق في تعديل أي مستند أو معلومات على هذا التطبيق/الموقع في أي وقت، دون التزام بتحديث أي معلومات على هذه الصفحة، وأنت توافق على أنه من مسؤوليتك مراقبة أي تغييرات.",
  "SECTION 4 – MODIFICATIONS TO PRICES AND SERVICES": "القسم 4 – التعديلات على الأسعار والخدمات",
  "We reserve the right to change the prices of our products without notice at any time or to discontinue the service or any part of it without notice at any time. We shall not be liable to you or any third party for any modification, price change, or discontinuation of the service.": "نحتفظ بالحق في تغيير أسعار منتجاتنا دون إشعار في أي وقت أو إيقاف الخدمة أو أي جزء منها دون إشعار في أي وقت. نحن غير مسؤولين تجاهك أو أي طرف ثالث عن أي تعديل أو تغيير في الأسعار أو إيقاف الخدمة.",
  "SECTION 5 – PRODUCTS OR SERVICES (if applicable)": "القسم 5 – المنتجات أو الخدمات (إذا كانت قابلة للتطبيق)",
  "Certain products or services may be available exclusively through the application/site. We also reserve the right to limit quantities and apply return and exchange policies in accordance with our policy.": "قد تكون بعض المنتجات أو الخدمات متاحة حصريًا من خلال التطبيق/الموقع. كما نحتفظ بالحق في تحديد الكميات وتطبيق سياسات الإرجاع والاستبدال وفقًا لسياساتنا.",
  "We strive to display products as accurately as possible in terms of sizes and colors, but we cannot guarantee that the display of any color on your computer monitor will be accurate. We reserve the right to limit our products to any person, geographic region, or jurisdiction. We do not warrant that the quality of any products, services, information, or other materials purchased by you will meet your expectations, or that any errors in the service will be corrected.": "نحن نسعى لعرض المنتجات بأكبر دقة ممكنة من حيث الأحجام والألوان، ولكن لا يمكننا ضمان أن عرض أي لون على شاشة الكمبيوتر الخاص بك سيكون دقيقًا. نحتفظ بالحق في تحديد منتجاتنا لأي شخص أو منطقة جغرافية أو اختصاص قضائي. نحن لا نضمن أن جودة أي من المنتجات أو الخدمات أو المعلومات أو المواد الأخرى التي تم شراؤها منك ستلبي توقعاتك، أو أن أي أخطاء في الخدمة سيتم تصحيحها.",
  "SECTION 6 – BILLING AND ACCOUNT INFORMATION": "القسم 6 – الفواتير ومعلومات الحساب",
  "We reserve the right to refuse any order you place with us. We may, at our sole discretion, limit or cancel quantities purchased per person, per household, or per order. These restrictions may include orders placed by or under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping address. In the event we make a change to or cancel an order, we may attempt to notify you by contacting the email and/or billing address/phone number provided at the time the order was made. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers, or distributors.": "نحتفظ بالحق في رفض أي طلب تقوم به معنا. قد نقوم، حسب تقديرنا الخاص، بتحديد أو إلغاء الكميات المشتراة لكل شخص أو لكل أسرة أو لكل طلب. قد تشمل هذه القيود الطلبات التي تم إجراؤها من نفس حساب العميل أو نفس بطاقة الائتمان و/أو الطلبات التي تستخدم نفس عنوان الفوترة و/أو الشحن. في حال أجرينا تغييرًا أو ألغينا طلبًا، قد نحاول إبلاغك عبر الاتصال بالبريد الإلكتروني و/أو عنوان الفوترة/رقم الهاتف الذي تم تقديمه عند إجراء الطلب. نحتفظ بالحق في تحديد أو حظر الطلبات التي، حسب تقديرنا الخاص، تبدو وكأنها تم وضعها من قبل تجار أو بائعين أو موزعين.",
  "You agree to provide current, complete, and accurate purchase and account information for all purchases made at our store. You agree to promptly update your account and other information, including your email address and credit card numbers and expiration dates, so that we can complete your transactions and contact you as needed. For more details, please review our Return Policy.": "أنت توافق على تقديم معلومات شراء وحساب حالية وكاملة ودقيقة لجميع المشتريات التي تتم في متجرنا. أنت توافق على تحديث حسابك والمعلومات الأخرى على الفور، بما في ذلك عنوان بريدك الإلكتروني وأرقام بطاقات الائتمان وتواريخ انتهاء الصلاحية، بحيث يمكننا إتمام معاملتك والتواصل معك حسب الحاجة. لمزيد من التفاصيل، يرجى مراجعة سياسة الإرجاع لدينا.",
  "SECTION 7 – OPTIONAL TOOLS": "القسم 7 – الأدوات الاختيارية",
  "We may provide you with access to third-party tools over which we neither monitor nor have any control or input. You acknowledge and agree that we provide access to such tools \"as is\" and \"as available\" without any warranties, representations, or conditions of any kind and without any endorsement. Any use by you of optional tools offered through the site/application is entirely at your own risk and discretion, and you should ensure that you are familiar with and approve the terms on which tools are provided by the relevant third-party provider. We may also, in the future, offer new services and/or features through the site/application (including the release of new tools and resources). Such new features and/or services shall also be subject to these TERMS AND CONDITIONS.": "قد نوفر لك الوصول إلى أدوات طرف ثالث لا نراقبها أو نتحكم فيها أو نساهم فيها. أنت تقر وتوافق على أننا نوفر الوصول إلى هذه الأدوات \"كما هي\" و\"كما هي متاحة\" دون أي ضمانات أو تمثيلات أو شروط من أي نوع ودون أي تأييد. أي استخدام من قبلك للأدوات الاختيارية التي يتم تقديمها عبر الموقع/التطبيق هو تمامًا على مسؤوليتك الشخصية واختيارك، ويجب عليك التأكد من أنك على دراية وموافقة على الشروط التي يتم بموجبها توفير الأدوات من قبل مزود الطرف الثالث المعني. قد نقدم أيضًا في المستقبل خدمات و/أو ميزات جديدة عبر الموقع/التطبيق (بما في ذلك إطلاق أدوات وموارد جديدة). يجب أن تخضع هذه الميزات والخدمات الجديدة أيضًا لهذه الشروط والأحكام.",
  "SECTION 8 – PERSONAL INFORMATION": "القسم 8 – المعلومات الشخصية",
  "Your submission of personal information is governed by our Privacy Policy, following all applicable laws and regulations.": "تخضع تقديمك للمعلومات الشخصية لسياسة الخصوصية الخاصة بنا، وفقًا لجميع القوانين واللوائح المعمول بها.",
  "SECTION 9 – DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY": "القسم 9 – إخلاء المسؤولية عن الضمانات؛ تحديد المسؤولية",


  "We do not guarantee, represent, or warrant that your use of our service will be uninterrupted, timely, secure, or error-free.": "نحن لا نضمن أو نمثل أو نضمن أن استخدامك لخدمتنا سيكون دون انقطاع أو في الوقت المحدد أو آمنًا أو خاليًا من الأخطاء.",
  "We do not warrant that the results that may be obtained from the use of the service will be accurate or reliable.": "نحن لا نضمن أن النتائج التي قد يتم الحصول عليها من استخدام الخدمة ستكون دقيقة أو موثوقة.",
  "You agree that from time to time we may remove the service for indefinite periods or cancel the service at any time, without notice to you.": "أنت توافق على أنه من وقت لآخر قد نقوم بإيقاف الخدمة لفترات غير محددة أو إلغاء الخدمة في أي وقت، دون إشعار لك.",
  "You expressly agree that your use of, or inability to use, the service is at your sole risk. The service and all products and services delivered to you through the service are (except as expressly stated by us) provided 'as is' and 'as available' for your use, without any representation, warranties, or conditions of any kind, either express or implied, including all implied warranties or conditions of merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.": "أنت توافق صراحةً على أن استخدامك للخدمة أو عدم قدرتك على استخدامها يكون على مسؤوليتك الخاصة. الخدمة وجميع المنتجات والخدمات المقدمة لك من خلال الخدمة هي (ما عدا ما هو مذكور صراحةً من قبلنا) مقدمة 'كما هي' و'كما هي متاحة' لاستخدامك، دون أي تمثيل أو ضمانات أو شروط من أي نوع، سواء كانت صريحة أو ضمنية، بما في ذلك جميع الضمانات أو الشروط الضمنية من قابلية التجارة والجودة التجارية والملاءمة لغرض معين، والمتانة، والعنوان، وعدم الانتهاك.",
  "In no case shall we, our directors, officers, employees, affiliates, agents, contractors, interns, suppliers, service providers, or licensors be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind, including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising from your use of any of the service or any products procured using the service, or for any other claim related in any way to your use of the service or any product, including, but not limited to, any errors or omissions in any content, or any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted, transmitted, or otherwise made available via the service, even if advised of their possibility. Because some states or jurisdictions do not allow the exclusion or limitation of liability for consequential or incidental damages, in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.": "في أي حال من الأحوال، لا نتحمل نحن، أو مديرونا، أو موظفونا، أو وكلاؤنا، أو مقاولونا، أو المتدربون، أو الموردون، أو مقدمو الخدمات، أو المرخصون أي مسؤولية عن أي إصابة أو خسارة أو مطالبة أو أي أضرار مباشرة أو غير مباشرة أو عرضية أو تأديبية أو خاصة أو تبعية من أي نوع، بما في ذلك على سبيل المثال لا الحصر الأرباح المفقودة أو الإيرادات المفقودة أو المدخرات المفقودة أو فقدان البيانات أو تكاليف الاستبدال أو أي أضرار مماثلة، سواء كانت قائمة على العقد أو الضرر (بما في ذلك الإهمال) أو المسؤولية الصارمة أو غير ذلك، الناشئة عن استخدامك لأي من الخدمة أو أي من المنتجات المشتراة باستخدام الخدمة، أو عن أي مطالبة أخرى ذات صلة بأي شكل من الأشكال باستخدامك للخدمة أو أي منتج، بما في ذلك على سبيل المثال لا الحصر، أي أخطاء أو سهو في أي محتوى، أو أي فقدان أو ضرر من أي نوع يحدث نتيجة لاستخدام الخدمة أو أي محتوى (أو منتج) تم نشره أو نقله أو توفيره بأي شكل آخر عبر الخدمة، حتى إذا تم تحذيرك من إمكانية حدوثها. لأن بعض الدول أو السلطات القضائية لا تسمح بإقصاء أو تحديد المسؤولية عن الأضرار التبعية أو العرضية، في تلك الدول أو السلطات القضائية، ستقتصر مسؤوليتنا على الحد الأقصى المسموح به بموجب القانون.",
  "SECTION 10 – TERMINATION OF SERVICE": "القسم 10 – إنهاء الخدمة",
  "You may terminate this agreement at any time by notifying us that you no longer wish to use our services or when you cease using our site/application. Both parties may terminate this agreement at any time, and any charges or other information and pending procedures will be handled directly by the contract termination department.": "يمكنك إنهاء هذه الاتفاقية في أي وقت عن طريق إخطارنا بأنك لم تعد ترغب في استخدام خدماتنا أو عندما تتوقف عن استخدام موقعنا/تطبيقنا. يمكن للطرفين إنهاء هذه الاتفاقية في أي وقت، وسيتم التعامل مع أي رسوم أو معلومات أخرى وإجراءات معلقة مباشرة من قبل قسم إنهاء العقد.",
  "SECTION 11 – CUSTOMER SERVICE": "القسم 11 – خدمة العملاء",
  "You will always have access to our customer service, whether by email, online chat on our site/application, or via our WhatsApp number. It is your responsibility to contact us whenever you have any questions or situations that may compromise your data or the processing of your information on our site/application. Response times vary depending on the inquiry sent, between 48 to 72 business hours.": "ستتمكن دائمًا من الوصول إلى خدمة العملاء لدينا، سواء عبر البريد الإلكتروني أو الدردشة عبر الإنترنت على موقعنا/تطبيقنا أو من خلال رقم WhatsApp الخاص بنا. من مسؤوليتك الاتصال بنا كلما كانت لديك أي أسئلة أو مواقف قد تعرض بياناتك أو معالجة معلوماتك على موقعنا/تطبيقنا للخطر. تتفاوت أوقات الاستجابة حسب الاستفسار المرسل، بين 48 إلى 72 ساعة عمل.",
  "SECTION 12 – SHIPPING": "القسم 12 – الشحن",
  "Logistics and shipment policies are covered in our Shipping Policy, following all applicable laws and regulations.": "سياسات اللوجستيات والشحن مغطاة في سياسة الشحن الخاصة بنا، وفقًا لجميع القوانين واللوائح المعمول بها.",
  "SECTION 13 – GOVERNING LAW": "القسم 13 – القانون الحاكم",
  "These TERMS AND CONDITIONS and any separate agreements whereby we provide you Services shall be governed by and construed in accordance with the laws of Hong Kong.": "تخضع هذه الشروط والأحكام وأي اتفاقيات منفصلة نقدم بموجبها خدماتنا لك وتفسر وفقًا لقوانين هونغ كونغ.",
  "SECTION 14 – CHANGES TO TERMS AND CONDITIONS": "القسم 14 – التغييرات في الشروط والأحكام",
  "You can review the most current version of the TERMS AND CONDITIONS OF USE at any time on this page. We reserve the right to update, change, or replace any part of": "يمكنك مراجعة النسخة الحالية من شروط وأحكام الاستخدام في أي وقت على هذه الصفحة. نحتفظ بالحق في تحديث أو تغيير أو استبدال أي جزء من",

  "Thank you for your interest in Comexbcn.": "شكرًا لاهتمامك بـ Comexbcn.",
  "Our commitment is to deliver quality service with transparency and efficiency, offering various shipping options worldwide. We have a decade of experience in this field, with hundreds of satisfied customers.": "نحن ملتزمون بتقديم خدمة عالية الجودة بشفافية وكفاءة، مع توفير خيارات شحن متنوعة عالميًا. لدينا عقد من الخبرة في هذا المجال، مع مئات العملاء الراضين.",
  "Below are the terms and conditions of our shipping policy.": "فيما يلي الشروط والأحكام الخاصة بسياسة الشحن لدينا.",
  "1. Processing and Shipping Time": "1. وقت المعالجة والشحن",
  "Processing time is typically between 2 to 4 days after payment confirmation. During this period, we will prepare your order.": "عادةً ما يكون وقت المعالجة بين يومين إلى أربعة أيام بعد تأكيد الدفع. خلال هذه الفترة، سنقوم بتحضير طلبك.",
  "If there are any irregularities, we will contact you.": "إذا كانت هناك أي مخالفات، سنتصل بك.",
  "2.1 International Shipping": "2.1 الشحن الدولي",
  "Comexbcn offers international shipping. For any questions, please contact us through [our website](https://www.comexbcn.com).": "تقدم Comexbcn شحنًا دوليًا. لأي استفسارات، يرجى الاتصال بنا عبر [موقعنا الإلكتروني](https://www.comexbcn.com).",
  "Delivery Estimates and Applicable Fees": "تقديرات التوصيل والرسوم المطبقة",
  "We understand the importance of knowing the best market practices to minimize costs without compromising service quality. Comexbcn operates with transparency, providing realistic deadlines to avoid surprises during the process. Before finalizing your order, all timelines and costs will be available for your review. The delivery period starts from the moment the shipment is dispatched, not the order date. It's important to note that delivery estimates are not guaranteed. We do our best to meet your order requirements, but unexpected situations such as weather changes, attacks, force majeure, and other external events can delay delivery.": "نحن نفهم أهمية معرفة أفضل الممارسات في السوق لتقليل التكاليف دون التأثير على جودة الخدمة. تعمل Comexbcn بشفافية، حيث تقدم تواريخ نهائية واقعية لتجنب المفاجآت خلال العملية. قبل إنهاء طلبك، ستكون جميع الجداول الزمنية والتكاليف متاحة للمراجعة. يبدأ فترة التوصيل من لحظة إرسال الشحنة، وليس من تاريخ الطلب. من المهم ملاحظة أن تقديرات التوصيل غير مضمونة. نبذل قصارى جهدنا لتلبية متطلبات طلبك، ولكن يمكن أن تؤدي المواقف غير المتوقعة مثل تغيرات الطقس، الهجمات، القوة القاهرة، والأحداث الخارجية الأخرى إلى تأخير التوصيل.",
  "3.1 Delivery Observations": "3.1 ملاحظات التوصيل",
  "a. The delivery date may vary depending on the carrier, delivery method, location, and items ordered.": "أ. قد يختلف تاريخ التوصيل اعتمادًا على الناقل وطريقة التوصيل والموقع والعناصر المطلوبة.",
  "b. Separate Product Deliveries": "ب. تسليم المنتجات بشكل منفصل",
  "Products may be delivered separately. When placing your order, please consider these factors for the estimated delivery date.": "قد يتم تسليم المنتجات بشكل منفصل. عند تقديم طلبك، يرجى أخذ هذه العوامل في الاعتبار لتاريخ التوصيل المتوقع.",
  "Transit Time: The time it takes for your shipment to move from our distribution center to the local carrier.": "وقت النقل: الوقت الذي يستغرقه شحنك للتحرك من مركز التوزيع لدينا إلى الناقل المحلي.",
  "Shipment Weight: Shipping costs are based on the weight of your package and the chosen delivery method.": "وزن الشحنة: تعتمد تكاليف الشحن على وزن طردك وطريقة التوصيل المختارة.",
  "The final cost of your order can be seen after proceeding to the final checkout screen. Shipping costs will be displayed when you finalize your order.": "يمكنك رؤية التكلفة النهائية لطلبك بعد الانتقال إلى شاشة الدفع النهائية. سيتم عرض تكاليف الشحن عند إنهاء طلبك.",
  "Tracking": "التتبع",
  "As previously mentioned, Comexbcn operates transparently and always opts for tracked shipping to ensure peace of mind throughout the process. After completing a purchase with us, you will have access to tracking your order.": "كما ذكرنا سابقًا، تعمل Comexbcn بشفافية وتختار دائمًا الشحن المراقب لضمان راحة بالك طوال العملية. بعد إتمام عملية الشراء معنا، سيكون لديك الوصول لتتبع طلبك.",
  "Damages": "الأضرار",
  "If you notice any damage upon delivery, please contact us promptly through our WhatsApp support or via our [website](https://www.comexbcn.com).": "إذا لاحظت أي ضرر عند التسليم، يرجى الاتصال بنا على الفور من خلال دعمنا على WhatsApp أو عبر [موقعنا الإلكتروني](https://www.comexbcn.com).",
  "Lost Package": "الطرد المفقود",
  "While rare, if a package is lost, please check possible locations where the delivery person might have left it, including with neighbors. Before contacting us, we kindly ask you to check all possible locations to avoid unnecessary steps. If you still cannot locate the package, contact us via [our website](https://www.comexbcn.com) to report the lost package.": "على الرغم من أنها نادرة، إذا فقد الطرد، يرجى التحقق من الأماكن الممكنة التي قد يكون تركها فيها الشخص المرسل، بما في ذلك الجيران. قبل الاتصال بنا، نطلب منك بلطف التحقق من جميع المواقع الممكنة لتجنب الخطوات غير الضرورية. إذا كنت لا تزال غير قادر على العثور على الطرد، اتصل بنا عبر [موقعنا الإلكتروني](https://www.comexbcn.com) للإبلاغ عن الطرد المفقود.",
  "Miscellaneous Questions": "أسئلة متنوعة",
  "For any questions not mentioned here, please do not hesitate to contact us. We also have a FAQ page that may be useful for your situation. Visit our website: [www.comexbcn.com](https://www.comexbcn.com).": "لأي استفسارات لم يتم ذكرها هنا، لا تتردد في الاتصال بنا. لدينا أيضًا صفحة أسئلة متكررة قد تكون مفيدة لحالتك. قم بزيارة موقعنا الإلكتروني: [www.comexbcn.com](https://www.comexbcn.com).",
  "正在处理中，请勿重复操作": "جاري المعالجة، يرجى عدم تكرار العملية.",
  "Provide product link": "توفير رابط المنتج",
  "Remove All": "إزالة الكل",
  "Vendor quoted order": "طلب تم تسعيره من البائع",
  "Real Paid": "تم الدفع الفعلي",
  "SKU": "SKU",
  "Oops, no data found! Try a different search or check back later.": "عذرًا، لم يتم العثور على بيانات! جرب بحثًا مختلفًا أو تحقق لاحقًا.",
  "Item Amount": "مبلغ العنصر",
  "Discount Amount": "مقدار الخصم",
  "CreatedAt": "تم الإنشاء في",
  "PaidAt": "تم الدفع في",
  "DeliverAt": "تم الشحن في",
  "Contact Information": "معلومات الاتصال",
  "Zipcode": "الرمز البريدي",
  "Phone number": "رقم الهاتف",
  "E-mail": "البريد الإلكتروني",
  "Track Company": "شركة التتبع",
  "Notes": "ملاحظات",
  "Apartment, sulte": "شقة، جناح",
  "Name": "الاسم",
  "Contacts": "جهات الاتصال",
  "Time": "الوقت",
  "Goods Name": "اسم السلعة",
  "Goods Property": "خاصية السلعة",
  "Shipping address": "عنوان الشحن",
  "Re-quote": "إعادة التسعير",
  "Restore": "استعادة",
  "Affiliates InvitationLink": "رابط دعوة الشركاء",
  "Invitation Link": "رابط الدعوة",

  "keywords": "الكلمات المفتاحية",
  "Rest of the price ranges": "بقية نطاقات الأسعار",
  "Convert Currency": "تحويل العملة",
  "Tips": "نصائح",
  "Delete Completed": "حذف المكتمل",
  "Order Date": "تاريخ الطلب",
  "Created Time": "وقت الإنشاء",
  "Start": "البداية",
  "End": "النهاية",
  "Preview": "معاينة",
  "Platform": "المنصة",
  "Select Platform": "اختر المنصة",
  "Recommended hot search": "البحث الشائع الموصى به",
  "Logistics synchronization failed": "فشل في مزامنة اللوجستيات",
  "Fulfillment Status Abnormal": "حالة التنفيذ غير طبيعية",

  "Auth Status": "حالة التوثيق",
  "Unauthorized": "غير مصرح",
  "Whether to host": "هل ترغب في الاستضافة؟",
  "Payment code": "رمز الدفع",
  "Billing Detail": "تفاصيل الفاتورة",
  "Reason": "السبب",
  "Video": "فيديو",
  "Image": "صورة",
  "Deposit": "دفعة مقدمة",
  "Last update": "آخر تحديث",
  "Message": "رسالة",
  "Leave Message": "اترك رسالة",
  "Message Record": "سجل الرسائل",
  "Support Request": "طلب دعم",
  "Your browser does not support the video tag": "متصفحك لا يدعم وسم الفيديو",
  "Create a ticket": "طلب دعم",
  "Issue Type": "نوع المشكلة",
  "General Inquiry": "استفسار عام",
  "Order Issue": "مشكلة في الطلب",
  "Billing/Payment": "الفوترة / الدفع",
  "Account Support": "دعم الحساب",
  "Product Feedback": "ملاحظات المنتج",
  "Complaint": "شكوى",
  "Other": "أخرى",
  "Search products": "البحث عن المنتجات",
  "Me": "أنا",
  "Profile": "الملف الشخصي",
  "SEARCH": "يبحث",
  "Provide link": "توفير الرابط",
  "Full Name": "الاسم الكامل",
  "Location": "موقع",
  "Add": "يضيف",
  "Verify": "يؤكد",
  "Captcha": "كابتشا",
  "Modify User Phone": "تعديل رقم هاتف المستخدم",
  "Modify User Email": "تعديل بريد المستخدم الإلكتروني",
  "Offline Order": "عرض سعر دون طلبات حالية",
  "Offline Orders": "عرض سعر دون طلبات حالية",
  "Add New One": "أضف واحدًا جديدًا",
  "Dropshipping": "دروبشيبينغ",
  "Cargo": "استيراد",
  "Price Expect": "السعر المتوقع",
  "Pictures": "صور",
  "COMPLETED": "مكتمل",
  "FAIL": "يفشل",
  "Wait For Quote": "انتظر عرض الأسعار",
  "At least one image is required.": "يجب أن تكون هناك صورة واحدة على الأقل.",
  "Max 5 images allowed.": "الحد الأقصى المسموح به هو 5 صور.",
  "Title is required.": "العنوان مطلوب.",
  "Country is required.": "البلد مطلوب.",
  "Minimum price is required.": "يجب أن يكون السعر الأدنى.",
  "Maximum price is required.": "يجب تحديد السعر الأقصى.",
  "Link": "رابط المنتج",
  "Min":"الحد الأدنى",
  "Max":"الأعلى",
  "Collapse": "ينهار",

  //Categories
  "Access Control": "مراقبة الدخول",
  "Access Control Cards": "بطاقات التحكم في الوصول",
  "Access Control Kits": "مجموعات التحكم في الوصول",
  "Accessories": "ملحقات",
  "Accessories & Others": "الملحقات و أخرى",
  "Accessories & Parts": "الملحقات وقطع الغيار",
  "Acetate Frames": "إطارات خلات السيلولوز",
  "Action & Toy Figures": "دمى الحركة والدمى",
  "Action Figure": "دمية الحركة",
  "Active Bras": "الحمالات الرياضية",
  "Activity & Gear": "النشاط والمعدات",
  "Add On Cards & Controller Panels": "البطاقات الإضافية ولوحات التحكم",
  "Adhesive Paper": "ورق لاصق",
  "Adhesives": "مواد لاصقة",
  "Advanced Storage & RAM": "التخزين المتقدم وذاكرة الوصول العشوائي",
  "Africa Clothing": "ملابس إفريقيا",
  "African American Wigs": "باروكات الأمريكيين الأفارقة",
  "Air Cooler": "مروحة تبريد الهواء",
  "Air Intake & Fuel Delivery": "مدخل الهواء وتوصيل الوقود",
  "Air Intake Systems": "أنظمة دخول الهواء",
  "Air Purifier": "منظف الهواء",
  "Air Quality": "جودة الهواء",
  "Alarm Sensor": "مستشعر الإنذار",
  "Alarm System Kit": "مجموعة نظام الإنذار",
  "Animal Figure": "دمية الحيوان",
  "Animal Print Shoulder Bag": "حقيبة كتف بطباعة حيوانات",
  "Ankle Boots": "أحذية الكاحل",
  "Anti-Theft Backpack": "حقيبة ظهر مضادة للسرقة",
  "Apparels": "الملابس",
  "Aquarium Accessories & Equipment": "ملحقات وأدوات الحوض الزجاجي",
  "Aquarium Decors": "ديكورات الحوض الزجاجي",
  "Aquarium Lights": "إنارة الحوض الزجاجي",
  "Aquarium Pumps & Filters": "مضخات وفلاتر الحوض الزجاجي",
  "Aquariums & Fish Bowls": "الأحواض الزجاجية وأوعية السمك",
  "Art Supplies": "لوازم فنية",
  "Artificial Flower": "زهرة صناعية",
  "Asia & Pacific Islands Clothing": "ملابس آسيا وجزر المحيط الهادئ",
  "ATV & UTV Accessories": "ملحقات ATV وUTV",
  "Auto Fasteners & Clips": "أدوات تثبيت السيارات والمشابك",
  "Automatic Feeders": "مقصورة التغذية التلقائية",
  "Automatic Irrigation Equipment": "معدات الري التلقائي",
  "Automatic Irrigation System": "نظام الري التلقائي",
  "Automation Kits": "مجموعات الأتمتة",
  "Automobile Filter": "فلتر السيارة",
  "Automotive & Motorcycle": "السيارات والدراجات النارية",
  "Aviator jacket": "سترة الطيار",
  "Axe": "فأس",

  "Babies & Kids": "الأطفال والرضع",
  "Baby & Kids' Floats": "الطفاطيط للأطفال",
  "Baby Bottoms": "ملابس السباحة للرضع",
  "Baby Care": "عناية الرضع",
  "Baby Care Tools": "أدوات العناية بالرضع",
  "Baby Clothing": "ملابس الأطفال",
  "Baby Cribs": "أسرّة الأطفال",
  "Baby Dresses": "فساتين الرضع",
  "Baby Food Mills": "محضرات طعام الأطفال",
  "Baby Food Storage": "تخزين طعام الأطفال",
  "Baby Health Care": "العناية الصحية للرضع",
  "Baby Monitor": "مُراقب الطفل",
  "Baby Pillow & Cases": "وسادة الطفل وغطاءاتها",
  "Baby Playpens": "أقفاص اللعب للأطفال",
  "Baby Seats & Sofas": "مقاعد وأرائك الأطفال",
  "Baby Shoes": "أحذية الأطفال",
  "Baby Soap": "صابون الأطفال",
  "Baby Swimwears": "ملابس السباحة للأطفال",
  "Baby Toothbrushes": "فرشاة أسنان الأطفال",
  "Baby Tops": "قمصان الأطفال",
  "Baby Wet Wipes": "مناديل مبللة للأطفال",
  "Backpacks": "حقائب الظهر",
  "Backpacks & Carriers": "حقائب الظهر وحمالات الأطفال",
  "Badminton": "بادلنتون",
  "Bag Accessories": "ملحقات الحقائب",
  "Baggy Jeans": "جينز فضفاض",
  "Baggy Pants": "سراويل فضفاضة",
  "Bags": "حقائب",
  "Bagutte Bag": "حقيبة الباغيت",
  "Bandanas & Nightcaps": "وشاحات وقبعات النوم",
  "Bangs": "الشعر المنتوف",
  "Bar Stools": "كراسي بار",
  "Bar Tables": "طاولات بار",
  "Barebone & Mini Pc": "حواسيب صغيرة وكاملة",
  "Baseball Caps": "قبعات البيسبول",
  "Baseball Uniform": "زي البيسبول",
  "Basket": "سلة",
  "Bath Toys": "ألعاب الاستحمام",
  "Bathroom": "الحمام",
  "Bathroom Fixtures": "تركيبات الحمام",
  "Bathroom Hardwares": "أجهزة الحمام المعدنية",
  "Bathroom Sinks": "أحواض الغسيل في الحمام",
  "Bathtub Faucets": "حنفيات الحوض",
  "Bathtubs &Accessories": "أحواض الاستحمام والملحقات",
  "Batteries": "بطاريات",
  "Beach Chairs": "كراسي الشاطئ",
  "Beach Sand Toys": "ألعاب الرمال الشاطئية",
  "Beaded Necklace": "عقد مصنوع من الخرز",
  "Beard": "اللحية",
  "Beauty & Health": "الجمال والصحة",
  "Bed Linens": "أغطية الأسرّة",
  "Bedding Basics": "أساسيات الفراش",
  "Bedding Sets": "مجموعات الفراش",
  "Bedroom": "غرفة النوم",
  "Bedroom Furniture": "أثاث غرفة النوم",
  "Beds & Furnitures": "الأسرّة والأثاث",
  "Bedspreads & Coverlets": "أغطية الأسرّة والبطانيات",
  "Belly Button Ring": "حلقة السرة",
  "Belly Dancing": "رقص البطن",
  "Belt Accessories": "ملحقات الحزام",
  "Belts": "أحزمة",
  "Bending Machinery": "آلات الثني",
  "Bespoke Occasion Dresses": "فساتين حسب الطلب",
  "Bespoke Wedding Dress": "فستان زفاف مخصص",
  "Bicycle Bottle Holder": "حاملة زجاجة الدراجة",
  "Bicycle Protective Gear": "معدات الحماية للدراجة",
  "Bicycle Sticker": "ملصقات الدراجة",
  "Bikinis Sets": "مجموعات البيكيني",
  "Binder Paper": "ورق التجميع",
  "Bird Diapers": "حفاضات الطيور",
  "Birdcage Accessories": "ملحقات قفص الطيور",
  "Birds": "طيور",
  "Birthday & Balloon": "عيد ميلاد وبالونات",
  "BJD Dolls": "دمى BJD",
  "Blankets & Swaddles": "بطانيات ولفافات",
  "Blazer & Suits": "بدلات سهرة",
  "Blazers": "بدلات سهرة",
  "Blocks": "كتل",
  "Blue Light Blocking Glasses": "نظارات حجب الضوء الأزرق",
  "Board Card": "بطاقة لوحية",
  "Board Game": "لعبة لوحية",
  "Board Shorts": "شورت رياضي",
  "Boat Accessories": "ملحقات القوارب",
  "Boat Shoes": "أحذية القارب",
  "Body & Frames": "الجسم والإطارات",
  "Body Jewelry": "حلي الجسد",
  "Body Shaping Massage Equipment": "أجهزة تدليك لتنسيق الجسم",
  "Body Worn Camera": "كاميرا جسمانية",
  "Bodychain": "سلسلة الجسد",
  "Bodysuits": "بدلات كاملة",
  "Book Cover": "غلاف الكتاب",
  "Boots": "أحذية طويلة",
  "Boston Bag": "حقيبة بوسطن",
  "Bottles": "زجاجات",
  "Bottoms": "ملابس داخلية",
  "Bow Ties": "ربطة عنق على شكل فراشة",
  "Boxers & Briefs": "سراويل داخلية",
  "Boxes": "صناديق",
  "Bracelet & Bangles": "أساور",
  "Bras": "حمالات صدر",
  "Breifcases": "حقائب نقود",
  "Briefs": "سراويل داخلية",
  "Brooches": "دبابيس تزيينية",
  "Brushed jeans": "جينز مشطوف",
  "Bucket Bag": "حقيبة دلو",
  "Bug Zappers": "مصائد الحشرات الكهربائية",
  "Building & Construction Toys": "ألعاب البناء",
  "Bulletproof Protection": "حماية مضادة للرصاص",
  "Bumpers": "صدامات السيارات",
  "Business Backpack": "حقيبة ظهر للمكتب",
  "Business Garment Bag": "حقيبة ملابس رجال الأعمال",
  "Business Shoes": "أحذية عمل",
  "Business Supplies": "لوازم المكتب",
  "Bustiers & Corsets": "مشدات الصدر",
  "Cable Winder": "ملف الكابلات",
  "Cables Assemblies": "تجميع الكابلات",
  "Cages & Accessories": "أقفاص وملحقاتها",
  "Camcorders": "كاميرات الفيديو",
  "Camera & Photo": "كاميرا وتصوير",
  "Camera Power": "питание الكاميرا",
  "Camisoles & Tanks": "قمصان بدون أكمام",
  "Camping": "التخييم",
  "Camping Cookware": "أواني الطبخ للتخييم",
  "Camping Light": "إنارة التخييم",
  "Camping Trolley": "عربة التخييم",
  "Candle Making": "صنع الشموع",
  "Candles & Holders": "شموع وحاملات",
  "Canvas": "قماش",
  "Canvas Shoulder Bag": "حقيبة كتف من القماش",
  "Canvas Waist Pack": "حقيبة خصر من القماش",
  "Car Body Films": "أغشية هيكل السيارة",
  "Car Body Repair Tools": "أدوات إصلاح هيكل السيارة",
  "Car Covers": "أغطية السيارات",
  "Car Disassembly Tools": "أدوات تفكيك السيارات",
  "Car DVR": "مسجل سيارة",
  "Car Electrical Appliances": "أجهزة كهربائية للسيارة",
  "Car Electronic Accessories": "ملحقات إلكترونية للسيارة",
  "Car Electronics": "إلكترونيات السيارات",
  "Car Headlight Assembly": "تجميع مصابيح الأمام",
  "Car Headlight Bulbs": "مصباح أمامي للسيارة",
  "Car Intelligent Systems": "أنظمة ذكية للسيارات",
  "Car lacks & Lifting Equipment": "مستودعات ورفع المعدات",
  "Car Light Assemblies": "تجميع مصابيح السيارات",
  "Car Lights": "مصابيح السيارات",
  "Car Repair Tools": "أدوات إصلاح السيارات",
  "Car Seat Covers": "أغطية مقاعد السيارات",
  "Car Stickers": "ملصقات السيارات",
  "Card Cutter": "مقص البطاقات",
  "Cardigan": "سترة دون أزرار",
  "Cardigans": "سترات دون أزرار",
  "Cardio Training": "تدريبات القلب",
  "Cargo Shirt": "قميص عملي",
  "Cargo Shorts": "شورت عملي",
  "Carriers": "حمالات الأطفال",
  "Carriers & Strollers": "حمالات الأطفال وعربات الأطفال",
  "Carry-Ons Luggage": "حقائب يدوية",
  "Case": "حالة",
  "Cashmere Wool Scarves": "أوشحة من الصوف الفاخر",
  "Casual Business": "ملابس عمل غير رسمية",
  "Casual Pants": "سراويل غير رسمية",
  "Casual Shoes": "أحذية غير رسمية",
  "Casual Sneaker": "حذاء رياضي غير رسمي",
  "Cat Doors, Steps, Nets & Pens": "أبواب، درج، شبكات، وحظائر للقطط",
  "Cats": "قطط",
  "CD Cases": "حالات الأقراص المدمجة",
  "CD Racks": "رفوف الأقراص المدمجة",
  "Ceramics & Pottery": "الفخار والخزف",
  "Chain Bag": "حقيبة سلسلة",
  "Chain Bracelet": "سوار سلسلة",
  "Chain Waist Pack": "حقيبة خصر بسلسلة",
  "Chains": "سلاسل",
  "Chair Leg Cove!": "مغطى لأرجل الكرسي",
  "Chaise Lounges": "كراسي استراحة",
  "Charger Cable": "كابل الشحن",
  "Charms": " charms",
  "Cheongsams": "فستان تشونغسام",
  "Chest Bags": "حقائب صدرية",
  "Children's Bookcases": "رفوف كتب الأطفال",
  "Children's Flats": "أحذية مسطحة للأطفال",
  "Children's Shoes": "أحذية الأطفال",
  "Chinese Folk Dance": "رقص شعبي صيني",
  "Chinese Style": "النمط الصيني",
  "Christmas Supplies": "لوازم عيد الميلاد",
  "Clamp Clip": "مشبك ثابت",
  "Clamp Holder": "حامل المشبك",
  "Clamps": "مشابك",
  "Clarinet": "الكلارينيت",
  "Classical Dance Costume": "زي الرقص الكلاسيكي",
  "Cleaning Appliances": "أجهزة التنظيف",
  "Clearance Lights Assembly": "تجميع مصابيح الإخلاء",
  "Clip-In Extensions": "تمديدات الشعر بالمشابك",
  "Cloth Dryer": "مجفف الملابس",
  "Coffee Grinders": "ماكينات طحن القهوة",
  "Coffee Tables": "طاولات القهوة",
  "Cold Room Systems": "أنظمة غرف التبريد",
  "Collars, Harnesses & Leashes": "أطواق، أحزمة، وسلال انزلاقية",
  "Communications": "الاتصالات",
  "Communications Antennas": "antenas الاتصالات",
  "Computer Components": "مكونات الكمبيوتر",
  "Computer Desks": "مكاتب الكمبيوتر",
  "Computer,Office & Education": "الكمبيوتر والمكتب والتعليم",
  "Conference Tables": "طاولات المؤتمرات",
  "Connectors": "موصلات",
  "Consumer Electronics": "الإلكترونيات الاستهلاكية",
  "Control Panties": "ملابس داخلية تحكمية",
  "Cooler Bag": "حقيبة تبريد",
  "Cooling Systems": "أنظمة التبريد",
  "Cosmetic Bag & Case": "حقيبة مستحضرات التجميل",
  "Cosplay Costumes": "أزياء Cosplay",
  "Cotton Linen Shirt": "قميص قطني",
  "Cotton Linen Shorts": "شورت قطني",
  "Cover-Ups": "ملابس فوق الملابس",
  "Cow Mastitis Detectors": "كاشفات التهاب ضرس البقر",
  "Cradles": "أراجيح",
  "Craft Toys": "ألعاب حرفيّة",
  "Crates, Houses & Pens": "صناديق، منازل، وحظائر",
  "Credit Card Holder": "حافظة بطاقات ائتمان",
  "Crochet Hair": "شعر مش crochet",
  "Crossbody Bags": "حقائب عبر الجسد",
  "Cultural Clothing": "ملابس ثقافية",
  "Cups": "أكواب",
  "Curly Wigs": "باروكات مجعدة",
  "Curve & Plus Size": "ملابس كبيرة الحجم",
  "Cushions": "وسائد",
  "Cycling": "ركوب الدراجات",
  "Cycling Bib Short": "شورت ركوب الدراجات",
  "Cycling Sunglasses": "نظارات شمسية للدراجات",
  "Cycling Vest": "سترة ركوب الدراجات",
  "Dancewear": "ملابس الرقص",
  "Decorative Mirrors": "مرايا زخرفية",
  "Deep Wave Wigs": "باروكات ذات تموج عميق",
  "Dehumidifier": "م Quitter للرطوبة",
  "Demon Slayer": "قاتل الشياطين",
  "Denim lacket": "جاكيت جينز",
  "Denim Shirt": "قميص جينز",
  "Denim Shorts": "شورت جينز",
  "Denim Shoulder Bag": "حقيبة كتف جينز",
  "Densitometers": "جهاز قياس الكثافة",
  "Dental Chair Cover": "غطاء كرسي الأسنان",
  "Dental consumable": "مواد استهلاكية لطب الأسنان",
  "Dental Drills & Brush": "محابر وفرشاة الأسنان",
  "Dental Grill": "شبكة تقويم الأسنان",
  "Dental Supplies": "لوازم طب الأسنان",
  "Dentist Seat": "كرسي طبيب الأسنان",
  "Derby Shoes": "أحذية ديربي",
  "Desktops": "حواسيب مكتبية",
  "Desktops & AIO": "حواسيب مكتبية و一体机",
  "Diagnostic Tools": "أدوات التشخيص",
  "Diamond Painting": "رسم الألماس",
  "Diaper Bags": "حقائب الحفاظات",
  "Dice": "نرد",
  "Diffuser Aromatherapy": "موزع العطور العطرية",
  "Digital Cameras": "كاميرات رقمية",
  "Digital Watches": "ساعات رقمية",
  "Dining Chairs": "كراسي طاولة الطعام",
  "Dining Room": "غرفة الطعام",
  "Dining Room Furniture": "أثاث غرفة الطعام",
  "Dining Room Sets": "مجموعات غرفة الطعام",
  "Dining Tables": "طاولات الطعام",
  "DIY Bags": "حقائب DIY",
  "DlY Accessories": "ملحقات DIY",
  "DlY Gaming Computer": "حاسوب ألعاب DIY",
  "Dogs": "كلاب",
  "Doll Houses": "منازل الدمى",
  "Dolls": "دمى",
  "Dolls & Accessories": "دمى وملحقات",
  "Dolls Accessories": "ملحقات الدمى",
  "Domino": "دومينو",
  "Door Remote Controls": "وحدات تحكم أبواب عن بعد",
  "Door Screen": "شاشة الباب",
  "Doorbell": "جرس الباب",
  "Double Breasted Suits": "بدلات مزدوجة الصدر",
  "Down Coats": "معاطف من الريش",
  "Down Jackets": "سترات من الريش",
  "Drawing": "الرسم",
  "Drawing Tablet": "لوح الرسم",
  "Drawing Toys": "ألعاب الرسم",
  "Drawstring Bag": "حقيبة بخيط",
  "Dress Sets": "مجموعات الفساتين",
  "Dressers": "خزائن الملابس",
  "Dresses": "فساتين",
  "Drop & Dangle Earring": "أقراط متدلية",
  "Dropper": "قطرة",
  "Drum": "طبل",
  "Dumbbells": "أوزان يدوية",
  "Duvets": "بطانيات",
  "Ear Piercing": "ثقب الأذن",
  "Ear Protection": "حماية الأذن",
  "Ear Tags": "علامات الأذن",
  "Earbuds": "سماعات الأذن",
  "earbuds": "سماعات الأذن",
  "Earring Set": "مجموعة أقراط",
  "Earrings": "أقراط",
  "Eas Kits": "مجموعات eas",
  "Easel": "حامل لوحة",
  "Electric Beverage Warmer": "سخّان مشروبات كهربائي",
  "Electric Cleaning Brush": "فرشاة تنظيف كهربائية",
  "Electric Espresso Pots": "آلة قهوة إسبرسو كهربائية",
  "Electric Fireplace": "محمصة كهربائية",
  "Electric Floor Mop": "مكنسة كهربائية للأرضيات",
  "Electric Heater": "سخان كهربائي",
  "Electric Scooter": "سكوتر كهربائي",
  "Electric Screwdriver": "مفك كهربائي",
  "Electric Sweeper": "مكنسة كهربائية",
  "Electric Toothbrushes": "فرشاة أسنان كهربائية",
  "Electric Water Heaters": "سخانات مياه كهربائية",
  "Electric Wrench": "مفتاح كهربائي",
  "Electrical & lgnitions": "الإلكترونيات ووحدات الإشعال",
  "Electrical Equipment & Supplies": "المعدات والإمدادات الكهربائية",
  "Electronic Blocks": "كتل إلكترونية",
  "Electronic Mosquito Killer": "قاتل البعوض الإلكتروني",
  "Electronic Pets": "حيوانات أليفة إلكترونية",
  "Electronic Toys": "ألعاب إلكترونية",
  "Electronic Watches": "ساعات إلكترونية",
  "Emergency Kits & Defense": "حقائب الطوارئ والدفاع",
  "End Tables": "طاولات جانبية",
  "Endoscope Camera": "كاميرا منظار داخلي",
  "Engine Oil": "زيت المحرك",
  "Engine Parts": "قطع محرك",
  "Engines & Components": "المحركات والمكونات",
  "Engines & Engine Parts": "المحركات وقطع الغيار",
  "Entertainment": "ترفيه",
  "European Clothing": "ملابس أوروبية",
  "EVA Slippers": "شبشب EVA",
  "Eve Massage Instrument": "جهاز تدليك Eve",
  "Exercise Wheels": "عجلات التمرين",
  "Exhaust Fan": "مروحة العادم",
  "Exhaust Systems": "أنظمة العادم",
  "Exotic Pants": "سراويل غريبة",
  "Exterior Accessories": "ملحقات خارجية",
  "Eyeglass Lenses": "عدسات نظارات",
  "Fabric & Lace": "القماش والدانتيل",
  "Face Recognition Locks": "قفل التعرف على الوجه",
  "Family Intelligence System": "نظام الذكاء العائلي",
  "Fantasy Figurine": "دمية فانتازيا",
  "Farm Animals": "الحيوانات الزراعية",
  "Fascia Gun": "مسدس الأنسجة الضامة",
  "Fashion Belts": "أحزمة الموضة",
  "Fashion Quartz Wristwatches": "ساعات معصم كوارتز للموضة",
  "Fashion Suits": "بدلات موضة",
  "Fashionable Canes": "عصي موضة",
  "Fasteners": "أدوات التثبيت",
  "Faucet Replacement Parts": "قطع غيار للحنفيات",
  "Feeding": "التغذية",
  "Feeding & Watering Supplies": "إمدادات التغذية والري",
  "Festive & Party Supplies": "لوازم الاحتفال والحفلات",
  "Fiber Optic Equipment": "معدات الألياف البصرية",
  "Filing & Binding Products": "منتجات الفرز والتجميع",
  "Filing Cabinets": "خزائن ملفات",
  "Films & Instant Photo Paper": "أفلام ورق لتصوير فوري",
  "Fingerprint Locks": "قفل بصمة الإصبع",
  "Fireplaces & Stoves": "مواقد ومدافئ",
  "First Aid Kits": "حقائب الإسعافات الأولية",
  "Fish & Aquatic Pets": "الأسماك والحيوانات المائية الأليفة",
  "Fish Finders": "كاشفات الأسماك",
  "Fish Toe": "سمكة صغيرة",
  "Fishing": "الصيد",
  "Fishing Bags": "حقائب الصيد",
  "Fishing Floats": "طافي الصيد",
  "Fishing Jerseys": "قمصان الصيد",
  "Fishing Tools": "أدوات الصيد",
  "Fitness Pedals": "دواسات اللياقة",
  "Flamenco": "رقص فلامنكو",
  "Flashlight": "مصباح يدوي",
  "Flat Sandals": "صندل مسطّح",
  "Flats": "أحذية مسطحة",
  "Flea & Tick Controls": "مواد تحكم في البراغيث والقراد",
  "Flip Flops": "شبشب",
  "Floor Heating Systems": "أنظمة تدفئة الأرضيات",
  "Floor Socks": "جوارب للأرضيات",
  "Flute": "فلوت",
  "Fomer": "فومر",
  "Food Service": "خدمات الطعام",
  "Formal Occasion Dresses": "فساتين مناسبات رسمية",
  "Four Wheel Electric Car": "سيارة كهربائية رباعية الدفع",
  "Fresh Air Ventilator": "منفذ هواء طازج",
  "Fuel Supply Systems": "أنظمة تزويد الوقود",
  "Fun Hats": "قبعات مرحة",
  "Fun Sunglasses": "نظارات شمسية مرحِّبة",
  "Funiture": "أثاث",
  "Funny Masks": "أقنعة مضحكَة",
  "Fur Shoulder Bag": "حقيبة كتف من الفراء",
  "G-String": "سلب جي سترنج",
  "Game Collection Cards": "بطاقات جمع الألعاب",
  "Game Deals": "صفقات الألعاب",
  "Games & Accessories": "ألعاب وملحقاتها",
  "Gaming Hardware": "عتاد الألعاب",
  "Gaming Keyboard": "لوحة مفاتيح ألعاب",
  "Gaming Motherboard": "لوحة أم لأجهزة الألعاب",
  "Gaming Mouse": "فأرة ألعاب",
  "Gaming PC Case": "هيكل حاسوب الألعاب",
  "Garden & Balcony": "الحديقة والشرفة",
  "Garden Buildings": "مباني الحديقة",
  "Garden Furniture Sets": "مجموعات أثاث الحديقة",
  "Garden Pots & Planters": "أواني وزرع الحديقة",
  "Garden Shredder": "مُفَرِّم الحديقة",
  "Garden Water Timers": "مؤقتات مياه الحديقة",
  "Gardening Supplies": "لوازم البستنة",
  "Gardening Tools": "أدوات الحدائق",
  "Garment Steamer": "جهاز تبخير الملابس",
  "Gems": "الأحجار الكريمة",
  "Genshin lmpact": "جينشن إمباكت",
  "Genuine Leather Sandals": "صندل جلد طبيعي",
  "Gift & Gift Bag": "هدية وحقيبة هدايا",
  "Glasses": "نظارات",
  "Gloves & Handwear": "قفازات ومستلزمات اليدين",
  "Glow Supplies": "لوازم الإضاءة",
  "GPS & Accessories": "GPS وملحقاته",
  "GPS Accessories": "ملحقات GPS",
  "GPS Tracker": "جهاز تتبع GPS",
  "Graphics Cards": "بطاقات الرسوميات",
  "Grooming": "العناية الشخصية",
  "Guitar": "غيتار",
  "Gym Shorts": "شورت الجيم",
  "Gyms & Playmats": "صالات الرياضة وسجاد اللعب",
  "Habitat Decors": "ديكورات الموطن",
  "Habitat Lights": "إنارة الموطن",
  "Hair Bundles with Closures": "bundles الشعر مع أغطية",
  "Hair Care": "العناية بالشعر",
  "Hair Dryer": "مجفف الشعر",
  "Hair Dryers": "مجففات الشعر",
  "Hair Elastics & Ties": "أربطة الشعر المطاطية",
  "Hair Extensions": "تمديدات الشعر",
  "Hair Extensions & Wigs": "تمديدات الشعر وباروكات",
  "Hair jewelry": "حلي الشعر",
  "Hair Pieces": "خصلات الشعر",
  "Hair Tools & Accessories": "أدوات الشعر وملحقاته",
  "Hair Toppers For Women": "تسريحات الشعر للنساء",
  "Hair Towel": "منشفة الشعر",
  "Hair Weaving": "تركيب الشعر",
  "Hairnets": "شبكات الشعر",
  "Hammocks": "أرجوحة الشجرة",
  "Hand Dryer": "مجفف اليدين",
  "Hand Grips": "مقابض اليد",
  "Hand Protection": "حماية اليد",
  "Hand Tools": "أدوات اليد",
  "Hand Towel": "منشفة اليد",
  "Hand Washer": "غسالة اليد",
  "Handbags": "حقائب اليد",
  "Handheld Game Players": "أجهزة ألعاب محمولة",
  "Handkerchief Towels": "مناشف منديل",
  "Handkerchiefs": "مناديل",
  "Hanfu": "هانفو",
  "Hard Baits": "طعم صلب",
  "Hardware": "العتاد",
  "Hats": "قبعات",
  "Hats, Scarves & Gloves": "قبعات، أوشحة، وقفازات",
  "Headband Wigs": "باروكات رأسية",
  "Headbands": "أربطة للرأس",
  "Headboards": "لوحات الرأسية للسرير",
  "Headwear": "غطاء الرأس",
  "Heating & Cooling": "التدفئة والتبريد",
  "Heating,Venting & Cooling": "التدفئة، التهوية، والتبريد",
  "Heeled Sandals": "صندل بكعب",
  "Helmets": "خوذات",
  "Hidden Heel": "كعب مخفي",
  "High Boots": "أحذية عالية",
  "High Density Lace Wigs": "باروكات كثيفة من الدانتيل",
  "High-Capactiy Backpack": "حقيبة ظهر عالية السعة",
  "Highchairs": "كراسي مرتفعة",
  "Hiking": "التنزه",
  "Hiking Scarves": "أوشحة التنزه",
  "Hiking Shoes": "أحذية التنزه",
  "Hiking Vests": "سترات التنزه",
  "Hippop Necklace": "قلادة الهيب هوب",
  "Hobby & Collectibles": "الهوايات والتحف",
  "Hobo Bags": "حقائب بوهيمية",
  "Holders & Stands": "الحوامل والأقواس",
  "Home & Garden": "المنزل والحديقة",
  "Home Appliances": "أجهزة المنزل",
  "Home Brewing & Wine Making Barware": "مشروبات محلية الصنع وصناعة النبيذ",
  "Home Fragrance": "عطور المنزل",
  "Home Improvenment & Lighting": "تحسين المنزل وإضاءته",
  "Home Office": "مكتب منزلي",
  "Home Safes & Safe Accessories": "خزائن الأمان وملحقاتها",
  "Homecoming Dresses": "فساتين العودة إلى الوطن",
  "Hooded Down jacket": "سترة بسحاب وبغطاء",
  "Hooks": "خطافات",
  "Hoop Earring": "حلقات الأذن",
  "Horizontal Bars": "قضبان أفقية",
  "Hotel Uniforms": "الزي الرسمي للفندق",
  "Household Appliances": "أجهزة منزلية",
  "Houses & Habitats": "المنازل والموطن",
  "Human Hair 360 Lace": "شعر بشري 360 دانتيل",
  "Human Hair Extensions": "تمديدات شعر بشري",
  "Human Hair Full Lace": "شعر بشري كامل الدانتيل",
  "Human Hair Ponytails": "ذيل حصان من الشعر البشري",
  "Human Hair T-Part": "T-part من الشعر البشري",
  "Humidifier": "مرطب الهواء",
  "Hvac Systems & Parts": "أنظمة HVAC وقطع الغيار",
  "Indoor Cycling Bikes": "دراجات داخلية",
  "Induction Cookers": "مواقد كهرومغناطيسية",
  "Inflatable Toys": "ألعاب هوائية",
  "Infrared Alarm Detector": "كاشف إنذار الأشعة تحت الحمراء",
  "Ink Bottle": "زجاجة الحبر",
  "Ink Supplies": "لوازم الحبر",
  "Insoles": "بطانات الأحذية",
  "Inspection Tools": "أدوات الفحص",
  "Instruments & Gauges": "الأدوات والعدادات",
  "Intercom": "جهاز الاتصال الداخلي",
  "Interior Accessories": "ملحقات داخلية",
  "Invisible Bras": "حمالات صدر غير مرئية",
  "iPhone": "iPhone",
  "Jackets": "سترات",
  "jackets": "سترات",
  "Jeams": "جينز",
  "Jeans": "جينز",
  "Jewelry & Watches": "الحلي والساعات",
  "Jewelry Findings": "مكونات المجوهرات",
  "Jewelry Making": "صنع المجوهرات",
  "Jewelry Packagings": "تغليف المجوهرات",
  "Jewelry Sets": "مجموعات المجوهرات",
  "Jewish Wigs": "باروكات يهودية",
  "JK Socks": "جوارب JK",
  "Jumbo Braids": "ضفائر كبيرة",
  "Jump Starters": "أجهزة تشغيل السيارة",
  "Jumpsuits": "بدلات",
  "K Gold": "ذهب K",
  "K Gold Bracelet": "سوار ذهب K",
  "K Gold Earring": "حلية أذن ذهب K",
  "Kalimba": "كاريمبا",
  "Kebaya": "كبابا",
  "Key Box": "صندوق المفاتيح",
  "Key Chains": "سلاسل المفاتيح",
  "Kid's Accessories": "ملحقات الأطفال",
  "Kid's Clothing": "ملابس الأطفال",
  "Kid's Luggage": "حقائب الأطفال",
  "Kids Canvas Shoe": "حذاء كانفاس للأطفال",
  "Kids Gifts": "هدايا للأطفال",
  "Kids' Balance Bikes": "دراجات توازن للأطفال",
  "Kids' Frames": "إطارات للأطفال",
  "Kids' Hair Accessories": "ملحقات شعر للأطفال",
  "Kids' Sun Hats": "قبعات الشمس للأطفال",
  "Kids' sunglasses": "نظارات شمسية للأطفال",
  "Kids' Swing Car": "عربة تأرجح للأطفال",
  "Kitchen": "مطبخ",
  "Kitchen Appliances": "أجهزة المطبخ",
  "Kitchen Cabinet Storage": "تخزين دولاب المطبخ",
  "Kitchen Faucets": "حنفيات المطبخ",
  "Kitchen Fixtures": "تركيبات المطبخ",
  "Kitchen Hardware": "عتاد المطبخ",
  "Kitchen Sinks": "أحواض المطبخ",
  "Kitchen Soap Dispensers": "موزع صابون المطبخ",
  "Knitted Dresses": "فساتين محبوكة",
  "Knitted Gloves": "قفازات محبوكة",
  "Knitwears": "ملابس محبوكة",
  "Lab Supplies": "لوازم المختبر",
  "Lace Braided Wigs": "باروكات ضفائر دانتيل",
  "Lace Wigs": "باروكات دانتيل",
  "lar": "lar",
  "Large Size Luggage": "حقائب كبيرة الحجم",
  "Laser Cutting Machine": "ماكينة قص ليزر",
  "Laser Engraving Machine": "ماكينة نقش ليزر",
  "Laser Levels": "مستوى الليزر",
  "Laundry Appliances": "أجهزة الغسيل",
  "Layered Necklace": "قلادة متعددة الطبقات",
  "lce Crushers": "كسارات الثلج",
  "lce Shorts": "شورت ثلج",
  "Leakage Detector": "كاشف التسرب",
  "Learning & Education": "التعلم والتعليم",
  "Leather Boots": "أحذية جلدية",
  "Leather Casual": "ملابس جلدية غير رسمية",
  "Leather Coat": "معطف جلدي",
  "Leather Pants": "سروال جلدي",
  "Leather Shoes": "أحذية جلدية",
  "Leather Waist Pack": "حقيبة خصر جلدية",
  "Leggings": "ساقيات",
  "lgnition Systems": "أنظمة الإشعال",
  "License Plate Recognition Camera": "كاميرا التعرف على لوحات السيارات",
  "Light Bulbs": "لمبات الإضاءة",
  "Lighting Bulbs & Tubes": "لمبات وأنابيب الإضاءة",
  "Lightweight Down Jacket": "سترة خفيفة من الريش",
  "Linear Guides": "دليل خطي",
  "Lingerie & Loungewear": "ملابس داخلية وملابس استراحة",
  "Links, Rings & Tubes": "وصلات، حلقات، وأنابيب",
  "Lint Remover": "إزالة الوبر",
  "Liquid Chalk": "طباشير سائل",
  "Litter & Housebreaking": "حفاضات المنزل وتدريب القطط",
  "Living Room": "غرفة المعيشة",
  "Living Room Cabinets": "خزائن غرفة المعيشة",
  "Living Room Chairs": "كراسي غرفة المعيشة",
  "Living Room Furniture": "أثاث غرفة المعيشة",
  "Living Room Sofas": "أرائك غرفة المعيشة",
  "Loafers": "أحذية بدون رباط",
  "Lolita": "لوليتي",
  "Long Down Coats": "معاطف طويلة من الريش",
  "Long Down Jacket": "سترة طويلة من الريش",
  "Long Dresses": "فساتين طويلة",
  "Long Sleeve Dresses": "فساتين بأكمام طويلة",
  "Long Sleeve Tees": "قمصان بأكمام طويلة",
  "Low Cut Socks": "جوارب منخفضة",
  "lron": "مكواة",
  "Luggage Covers": "أغطية الحقائب",
  "Luggage Tags": "علامات الحقائب",
  "Luggages & Bags": "حقائب وحقائب سفر",
  "Lunch Bag": "حقيبة الغداء",

  "Machine & Accessories": "الماكينات والملحقات",
  "Machine Tool Spindle": "محور أداة الآلة",
  "Magic Cubes": "المكعبات السحرية",
  "Magic Tricks": "خداع سحري",
  "Magnetic Materials": "مواد مغناطيسية",
  "Make Up": "مكياج",
  "make up tools": "أدوات المكياج",
  "Marble Runs": "مسارات الرخام",
  "Martin Boots": "أحذية مارتن",
  "Mary Janes": "أحذية ماري جين",
  "Massage & Relaxation": "تدليك واسترخاء",
  "Massage Roller": "أسطوانة التدليك",
  "Mat": "بسطة",
  "Matching Sets": "مجموعات متطابقة",
  "Material": "مواد",
  "Material Paper": "ورق المواد",
  "Math Toys": "ألعاب رياضيات",
  "Mattress Cover": "غطاء المرتبة",
  "Mattresses": "مراتب",
  "Measurement & Analysis Tools": "أدوات القياس والتحليل",
  "Mechanical Watches": "ساعات ميكانيكية",
  "Medical Uniforms": "زي طبي",
  "Memorials & Funerary": "تذكار وجنائز",
  "Men's Bags": "حقائب للرجال",
  "Men's Belts": "أحزمة للرجال",
  "Men's Boots": "أحذية للرجال",
  "Men's Causal Shoes": "أحذية غير رسمية للرجال",
  "Men's Clothing": "ملابس رجالية",
  "Men's Fold Wallet": "محفظة قابلة للطي للرجال",
  "Men's Leather Wallet": "محفظة جلدية للرجال",
  "Men's Necklace": "قلادة للرجال",
  "Men's Sandals & Slippers": "صندل وشبشب للرجال",
  "Men's Underwear": "ملابس داخلية للرجال",
  "Men's Wallet with Zipper": "محفظة للرجال بسحاب",
  "Men's Watches": "ساعات للرجال",
  "Menstrual Panties": "ملابس داخلية للحيض",
  "Messenger Bag": "حقيبة رسول",
  "Microscopes": "مجاهر",
  "Middle Heel": "كعب متوسط",
  "Middle Size Luggage": "حقائب بحجم متوسط",
  "Midi Dresses": "فساتين ميدي",
  "Military Boots": "أحذية عسكرية",
  "Minimizer Bras": "حمالات صدر مُصغّرة",
  "Mobile Phone Antennas": "antenne الهواتف المحمولة",
  "Mobile Phone Batteries": "بطاريات الهواتف المحمولة",
  "Mobile Phone Cables": "كابلات الهواتف المحمولة",
  "Mobile Phone Chargers": "شواحن الهواتف المحمولة",
  "Mobile Phone Flex Cables": "كابلات مرنة للهواتف المحمولة",
  "Mobile Phone Housings & Frames": "هياكل وإطارات للهواتف المحمولة",
  "Mobile Phone lcD Screens": "شاشات LCD للهواتف المحمولة",
  "Mobile Phones": "هواتف محمولة",
  "Moissanite Bracelet": "أسورة مويسيانيت",
  "Money & Banking ToyS": "ألعاب نقود ومصارف",
  "Mosquito Nets": "شبكات البعوض",
  "Mossinate": "مصنوع من الطحالب",
  "Mother Shoes": "أحذية الأم",
  "Motherboards": "لوحات أم",
  "Motorcycle & ATV": "دراجة نارية وعربة ثلاثية أو رباعية الدفع",
  "Motorcycle Gear": "معدات الدراجات النارية",
  "Motorcycle ltems": "عناصر الدراجات النارية",
  "Motorcycle Pants": "سراويل دراجات نارية",
  "Motorcycle Parts": "قطع غيار الدراجات النارية",
  "Motorcycles": "دراجات نارية",
  "MP3/MP4 Bags & Cases": "حقائب وحافظات MP3/MP4",
  "Mug Thermos": "كوب حراري",
  "Mules Sandals": "صندل مولز",
  "Multi-Purpose Bag": "حقيبة متعددة الاستخدامات",
  "Musical Instruments": "آلات موسيقية",
  "Mystery Box": "صندوق الغموض",
  "Natural Stone Bracelet": "أسورة حجر طبيعي",
  "Neck Fan": "مروحة العنق",
  "Neck Massage Instrument": "جهاز تدليك العنق",
  "Necklaces": "قلادات",
  "Needle": "إبرة",
  "Needle Arts & Craft": "فنون الحرف بالإبر",
  "New in": "جديد في",
  "New in Backpack": "جديد في الحقائب الظهرية",
  "New in Bracelets": "جديد في الأساور",
  "New in Coats & Jackets": "جديد في المعاطف والسُتر",
  "New in Dresses": "جديد في الفساتين",
  "New in Findings": "جديد في الملحقات",
  "New in Handbag": "جديد في الحقائب اليدوية",
  "New in Hoodies & Sweatshirts": "جديد في هوديز وقمصان فليسة",
  "New in Keychains": "جديد في سلاسل المفاتيح",
  "New in Knitwears": "جديد في الملابس المحبوكة",
  "New in Matching Sets": "جديد في مجموعات متطابقة",
  "New in Men's Sets": "جديد في مجموعات للرجال",
  "New in Men's Sleepwear": "جديد في ملابس نوم للرجال",
  "New in Men's Socks": "جديد في جوارب للرجال",
  "New in Men's Underwear": "جديد في ملابس داخلية للرجال",
  "New in Men's Watches": "جديد في ساعات للرجال",
  "New in Necklaces": "جديد في القلادات",
  "New in Outerwears": "جديد في الملابس الخارجية",
  "New in Pants": "جديد في السراويل",
  "New in Pants & Capris": "جديد في السراويل والسراويل القصيرة",
  "New in Rings": "جديد في الخواتم",
  "New in Shorts": "جديد في السراويل القصيرة",
  "New in Suits & Blazers": "جديد في البذلات والسترات",
  "New in Tops & Tees": "جديد في القمصان والبلوزات",
  "New in Women's Boots": "جديد في أحذية النساء",
  "New in Women's Sleepwear": "جديد في ملابس نوم للنساء",
  "New in Women's Socks": "جديد في جوارب النساء",
  "New in Women's Underwear": "جديد في الملابس الداخلية للنساء",
  "Nightgowns": "رداء الليل",
  "Nightstands": "طاولات جانبية",
  "Nose Nail": "مسامير الأنف",
  "Notebooks & Papers": "دفاتر وأوراق",
  "Nursery & Baby Furniture": "أثاث الأطفال والرضع",
  "O-Neck Pullovers": "قميص بأزرار على الرقبة",
  "Office Chairs": "كراسي مكتبية",
  "Office Furniture": "أثاث مكتبي",
  "One Piece Hats": "قبعات قطعة واحدة",
  "One Pieces": "قطعة واحدة",
  "Open Closets": "خزائن مفتوحة",
  "Other Apparel Accessories": "ملحقات أخرى للملابس",
  "Other Bags & Accessories": "حقائب وملحقات أخرى",
  "Other Jewalry": "مجوهرات أخرى",
  "Other Kid's Bags": "حقائب الأطفال الأخرى",
  "Outdoor Backpack": "حقيبة ظهر خارجية",
  "Outdoor Bags": "حقائب خارجية",
  "Outdoor Belts": "أحزمة خارجية",
  "Outdoor cooler": "مبرد خارجي",
  "Outdoor Drainage": "تصريف خارجي",
  "Outdoor Furniture": "أثاث خارجي",
  "Outdoor Heaters": "سخانات خارجية",
  "Outdoor Sandals": "صندل خارجي",
  "Outerwear": "ملابس خارجية",
  "Outerwears": "ملابس خارجية",
  "Over Knee": "فوق الركبة",
  "Oxfords": "أحذية أوكسفورد",
  "Pacifiers": "مصاصات",
  "Packing": "التعبئة",
  "Packing Box": "صندوق تعبئة",
  "Padlocks": "قفل",
  "Painting By Numbers": "رسم بالأرقام",
  "Painting Canva": "لوحة رسم",
  "Painting Supplies & Wall Treatments": "مستلزمات الرسم وديكور الجدران",
  "Pajama Sets": "مجموعات بيجامة",
  "Palette": "لوحة الألوان",
  "Panoramic Camera": "كاميرا بانورامية",
  "Pant Sets": "مجموعات سروال",
  "Panties": "ملابس داخلية نسائية",
  "Pants": "سراويل",
  "Paper": "ورق",
  "Paper Holder": "حامل الورق",
  "Paracord": "حبال مقاومة",
  "Parkas": "سترات ثقيلة",
  "Parking Lock": "قفل الوقوف",
  "Part Lace Wigs": "باروكات شعر مع دانتيل",
  "Party Dresses": "فساتين حفلات",
  "Party Games": "ألعاب حفلات",
  "Party Supplies": "لوازم الحفلات",
  "Party Wigs": "باروكات للحفلات",
  "Patio Umbrellas & Bases": "مظلات وقواعد لسطح المنزل",
  "PC Power Supplies": "مصدر طاقة للكمبيوتر",
  "Pearl": "لؤلؤة",
  "Pearl Necklace": "قلادة لؤلؤ",
  "Peephole": "عين الباب",
  "Pen Cap": "غطاء القلم",
  "Pen Head": "رأس القلم",
  "Pencil Case": "علبة أدوات الكتابة",
  "Pencil Pants": "سروال ضيق",
  "Pencil Pot": "علبة قلم رصاص",
  "Personal Care Appliances": "أجهزة العناية الشخصية",
  "Pet Supplies": "لوازم الحيوانات الأليفة",
  "Phone Cases": " أغلفة الهاتف",
  "Phone Repair Tools": "أدوات إصلاح الهاتف",
  "Phones & Telecommunications": "الهواتف والاتصالات",
  "Phones Accessories": "ملحقات الهواتف",
  "Phones Parts": "قطع هواتف",
  "Photo Albums": "ألبومات الصور",
  "Photo Studio Kits": "مجموعات استوديو تصوير",
  "Picture Card": "بطاقة صورة",
  "Piexi Cut Wigs": "باروكات بقصة Piexi",
  "Pigment": "صبغة",
  "Pillow Shoulder Bag": "حقيبة كتف على شكل وسادة",
  "Plaid Scarves": "أوشحة مربعة",
  "Plain Shirt": "قميص بسيط",
  "Play Mats": "بسط اللعب",
  "Playing Cards": "Cards لعبة",
  "Plumbing": "سباكة",
  "Plumbing Hoses": "خرطوم السباكة",
  "Plus Size Down Coats": "معاطف كبيرة الحجم",
  "Plus Size Dresses": "فساتين كبيرة الحجم",
  "Plus Size Matching Sets": "مجموعات متطابقة كبيرة الحجم",
  "Plus Size Outwears": "ملابس خارجية كبيرة الحجم",
  "Plus Size Panties": "ملابس داخلية كبيرة الحجم",
  "Plus Size Swimwears": "ملابس سباحة كبيرة الحجم",
  "Plus Size Tops": "قمصان كبيرة الحجم",
  "Plus Size Wedding Dress": "فساتين زفاف كبيرة الحجم",
  "Pneumatic Parts": "أجزاء هوائية",
  "Pointed Toe": "أحذية مدببة",
  "Polarized Sunglasses": "نظارات شمسية قطبية",
  "Polisher": "مُلمِّع",
  "Polo Shirts": "قمصان بولو",
  "Pools & Water Activities": "مسابح ونشاطات مائية",
  "Portable Television": "تلفزيون محمول",
  "Portable Washing Machine": "ماكينة غسيل محمولة",
  "Portfolio": "محفظة أعمال",
  "Postcard": "بطاقة بريدية",
  "Poster": "ملصق",
  "Power Banks": "بنوك طاقة",
  "Power Filters": "مرشحات طاقة",
  "Power Supplies": "مصدر طاقة",
  "Power Transmission Parts": "قطع نقل الطاقة",
  "Pre-Order": "طلب مسبق",
  "Prescription Glasses": "نظارات طبية",
  "Pressure Cookers": "قدر ضغط",
  "Priest Uniforms": "زي الكاهن",
  "Print Sweater": "سترة مطبوعة",
  "Print Waist Pack": "حزام خصر مطبوع",
  "Printed Shirt": "قميص مطبوع",
  "Programmable Toys": "ألعاب قابلة للبرمجة",
  "Prom Dresses": "فساتين حفلات تخرج",
  "Pullovers": "قمصان بدون أزرار",
  "Quartz Watches": "ساعات كوارتز",
  "Quick Dry Towel": "منشفة جافة سريعًا",
  "Quilts": "بطانيات",
  "Quinceanera Dresses": "فساتين عيد ميلاد 15 عامًا",
  "Racing Boats & Kayaking": "قوارب سباق وتجديف",
  "Racing Drones": "طائرات مُسيَّرة سباق",
  "Racquet Sports": "رياضة مضرب",
  "Rail Systems": "أنظمة سكك حديدية",
  "Rain Boots": "أحذية مطر",
  "RC Airplanes": "طائرات تحكم عن بعد",
  "RC Boats": "قوارب تحكم عن بعد",
  "RC Motorcycles": "دراجات نارية تحكم عن بعد",
  "RC Stunt Cars": "سيارات بهلوانية تحكم عن بعد",
  "RC Trains": "قطارات تحكم عن بعد",
  "Rear Bumper Lights Assembly": "تركيب مصابيح الصدام الخلفي",
  "Reborn Dolls": "دمى حديثة",
  "Relaxation Treatment": "علاج استرخاء",
  "Remote Control Toys": "ألعاب تحكم عن بعد",
  "Replacement Parts": "قطع غيار",
  "Reptiles & Amphibians": "زواحف وبرمائيات",
  "Resin DlY": "راتنج DIY",
  "Resistance Bands": "أشرطة مقاومة",
  "Respirator": "جهاز تنفس",
  "Restaurant Tables": "طاولات مطعم",
  "Ring Clip": "مشبك حلقة",
  "Ripped Jeans": "جينز تمزق",
  "Rom Strap Shoes": "أحذية بشريط",
  "Round Toe": "أحذية مستديرة الرأس",
  "Rugged Smartphones": "هواتف ذكية متينة",
  "Safes": "خزائن آمنة",
  "Safety Short Pants": "سراويل قصيرة آمنة",
  "Sandals": "صندل",
  "Sander": "مكنسة رملية",
  "Sashes": "أحزمة",
  "Scarves & Gloves": "أوشحة وقفازات",
  "School Supplies": "لوازم مدرسية",
  "Scouting Uniforms": "زي كشفي",
  "Screen Protectors": "واقي الشاشة",
  "Sculptures & Figurine": "تماثيل وتماثيل صغيرة",
  "Sculptures & Figurines": "تماثيل وتماثيل صغيرة",
  "Seamless Bras": "حمالات صدر بدون خياطة",
  "Security & Protection": "أمن وحماية",
  "Self Defense": "الدفاع عن النفس",
  "Sets": "مجموعات",
  "Sexy Panties": "ملابس داخلية جذابة",
  "Shapers": "شكلاء",
  "Sharpener": "削筆刀",
  "Sheet Sets": "مجموعات ملاءات",
  "Shelter": "ملجأ",
  "Shirt jacket": "سترة قميص",
  "Shirts": "قمصان",
  "Shirts & Blouses": "قمصان وبلوزات",
  "Shock Absorbers": "مخففات الصدمات",
  "Shoe Accessories": "ملحقات الأحذية",
  "Shoe Care Kit": "مجموعة العناية بالأحذية",
  "Shoe Decorations": "زينة الأحذية",
  "Shoe Dryer": "مجفف أحذية",
  "Shoe Polishes": "ملمعات الأحذية",
  "Shoelaces": "أربطة الأحذية",
  "Shoes": "أحذية",
  "Shoes Covers": "أغطية للأحذية",
  "Shopping Bag": "حقيبة تسوق",
  "Short Down Coats": "معاطف قصيرة",
  "Short Down lacket": "سترة قصيرة",
  "Short Dresses": "فساتين قصيرة",
  "Short Sets": "مجموعات قصيرة",
  "Shorts": "سراويل قصيرة",
  "Shoulder Bags": "حقائب كتف",
  "Shower System": "نظام الدش",
  "Signal Lamp Assemblies": "تركيبات لمبات الإشارة",
  "Silk Base Lace Wigs": "باروكات حريرية مع دانتيل",
  "Silk Scarves": "أوشحة حريرية",
  "Silk Scarves & Ribbons": "أوشحة حريرية وأشرطة",
  "Silver 925": "فضة 925",
  "Silver Bracelet": "أسورة فضة",
  "Silver Earring": "قرط فضة",
  "Silver Necklace": "قلادة فضة",
  "Single Breasted Suits": "بدلات أحادية الصدر",
  "Sit Up Benches": "مقاعد للجلوس",
  "Skateboard": "لوح تزلج",
  "Sketch": "رسمة",
  "Skirts": "تنانير",
  "Sleep & Lounge": "نوم واستراحة",
  "Sleeping Bags": "أكياس نوم",
  "Sleepwear": "ملابس نوم",
  "Slim leans": "جينز رفيع",
  "Small Animals": "حيوانات صغيرة",
  "Smart Bathroom": "حمام ذكي",
  "Smart Curtains": "ستائر ذكية",
  "Smart Dimmers": "مخففات ذكية",
  "Smart Electronics": "إلكترونيات ذكية",
  "Smart Home": "منزل ذكي",
  "Smart Remote Controls": "أجهزة تحكم ذكية",
  "Smart Smoke Detectors": "كاشفات دخان ذكية",
  "Smart Switches": "مفاتيح ذكية",
  "Smart Thermostats": "عدادات حرارة ذكية",
  "Smart Watches": "ساعات ذكية",
  "Smart Water Heaters": "سخانات مياه ذكية",
  "Smartphone 5g": "هاتف ذكي 5G",
  "Smartphone Android": "هاتف ذكي أندرويد",
  "Sneaker": "حذاء رياضي",
  "Snooker & Billiard Accessories": "ملحقات السنوكر والبلياردو",
  "Snow Boots": "أحذية ثلج",
  "Snowmobile Gears": "معدات دراجات الثلج",
  "Soccer Tables": "طاولات كرة القدم",
  "Socks": "جوارب",
  "Socks & Leg Warmers": "جوارب وسخّانات الساق",
  "Soft Plastic Blocks": "كتل بلاستيكية ناعمة",
  "Solar Inverters": "عاكسات الطاقة الشمسية",
  "Solar Panels": "لوحات الطاقة الشمسية",
  "Solar Water Heaters": "سخانات مياه تعمل بالطاقة الشمسية",
  "Solid Color Scarves": "أوشحة بلون واحد",
  "Sound Cards": "بطاقات صوت",
  "Special Occasion Costume": "زي ملابس مناسبات خاصة",
  "Special Occasion Dresses": "فساتين مناسبات خاصة",
  "Spectrum Analyzers": "محللي الطيف",
  "Spinning Top": "الدوران العلوي",
  "Sport Hoops": "حلقات رياضية",
  "Sport Waist Pack": "حزام رياضي للخصر",
  "Sports & Entertainment": "الرياضة والترفيه",
  "Sports & Outdoor Activities": "أنشطة رياضية وخارجية",
  "Sports Suits": "بدلات رياضية",
  "Sports Video Cameras": "كاميرات فيديو رياضية",
  "Sports Video Cameras Accessories": "ملحقات كاميرات الفيديو الرياضية",
  "Spray Gun": "مسدس رش",
  "Spy Family": "عائلة جاسوسة",
  "Square Bag": "حقيبة مربعة",
  "Stamp": "طابع",
  "Stamps Toys": "ألعاب الطوابع",
  "Stand Fan": "مروحة قائمية",
  "Stapler": "دباسة",
  "Stationary": "ثابت",
  "Steam Cleaner": "منظف بالبخار",
  "Steering Covers": "أغطية المقود",
  "Steppers": "آلات الخطوات",
  "Sticker Book": "كتاب ملصقات",
  "Stickers": "ملصقات",
  "Stickers & Poster": "ملصقات وملصقات إعلانية",
  "Sticky Notes": "ملاحظات لاصقة",
  "Stockings": "جوارب طويلة",
  "Stowing Tidying": "تخزين وتنظيم",
  "Straight Pants": "سروال مستقيم",
  "Strapless Bras": "حمالات صدر بدون حمالات",
  "Street Dance": "رقص الشارع",
  "Strength Training": "تدريبات القوة",
  "Striped Sweater": "سترة مخططة",
  "Suit jackets": "سترات بدلة",
  "Suit Pants": "سراويل بدلة",
  "Suits": "بدلات",
  "Sun Hats": "قبعات شمسية",
  "Sun Loungers": "كراسي استرخاء تحت الشمس",
  "Sunglasses": "نظارات شمسية",
  "Sunshades": "مظلات شمسية",
  "Super-High Heel": "كعب عالي جدًا",
  "Surfboard & Paddleboards": "لوح تزلج على الماء ولوح التجديف",
  "Surfing & Beach Shorts": "سراويل الشاطئ والتزلج على الماء",
  "Surfing & Kayaking": "التزلج على الماء والتجديف",
  "Surfing Accessories": "ملحقات التزلج على الماء",
  "Sweater Matching Sets": "مجموعات سترة",
  "Sweater Vest": "سترة بدون أكمام",
  "Sweaters": "سترات",
  "Sweatpants": "سراويل رياضية",
  "Swimming Pools": "مسابح",
  "Swimswears": "ملابس سباحة",
  "Synthetic Chignon": "كعكة شعر صناعية",
  "Synthetic Hair Lace": "شعر صناعي مع دانتيل",
  "Synthetic Ponytails": "ذيل حصان صناعي",
  "Table Decoration & Accessories": "ديكور الطاولة والملحقات",
  "Table Linens": "أقمشة الطاولة",
  "Table Tennis": "تنس الطاولة",
  "Tap Dance": "رقص على الأقدام",
  "Tapered jeans": "جينز مدبب",
  "Tapestries": "سجاد نسيجي",
  "Tattoo & Body Art": "وشم وفن الجسم",
  "Tattoo Grips": "مقابض الوشم",
  "Tattoo Inks": "حبر الوشم",
  "Tattoo Kits": "مجموعات الوشم",
  "Tattoo Machines": "آلات الوشم",
  "Tattoo Needles": "إبر الوشم",
  "Tattoo Power Supplies": "مصدر طاقة لآلات الوشم",
  "Teeth Whitening Instrument": "جهاز تبييض الأسنان",
  "Temperature Humidity Instruments": "أجهزة قياس الحرارة والرطوبة",
  "Temperature Sensor": "مستشعر الحرارة",
  "Tennis": "تنس",
  "Terrarium Bedding, Sands & Substrates": "فراش تيراريوم ورمال وركائز",
  "Terrarium Bowls": "أوعية تيراريوم",
  "Terrarium Heat Lamps & Mats": "مصباح وسجادة حرارة لتيراريوم",
  "Test Tube": "أنبوب اختبار",
  "Theodolites": "الذراعيات",
  "Thermal Underwear": "ملابس داخلية حرارية",
  "Thread Bracelet": "أسورة خيط",
  "Tie Clips & Cufflinks": "مشابك ربطة عنق ودبابيس أكمام",
  "Ties": "رباطات عنق",
  "Tig Welders": "لحام TIG",
  "Tights": "جوارب ضيقة",
  "Tire Repair Tools": "أدوات إصلاح الإطارات",
  "Tires": "إطارات",
  "Titanium Frames": "إطار من التيتانيوم",
  "Tools": "أدوات",
  "Tools & Industrial": "أدوات وصناعية",
  "Toothbrushes Head": "رأس فرشاة الأسنان",
  "Top Hats": "قبعات عالية",
  "Tops": "قمصان",
  "Toupee": "باروكة",
  "Towel": "منشفة",
  "Toy Balls": "كرات ألعاب",
  "Toy Cameras": "كاميرات ألعاب",
  "Toy Guns": "بنادق ألعاب",
  "Toy Musical Instrument": "آلات موسيقية ألعاب",
  "Toy Sports": "ألعاب رياضية",
  "ToyS": "ألعاب",
  "Toys": "ألعاب",
  "Toys & Games": "ألعاب ولعب",
  "Training Head Kit": "مجموعة رأس التدريب",
  "Trampolines": "ترامبولين",
  "Transformer Robot": "روبوت تحويل",
  "Translator": "مترجم",
  "Travel Bag": "حقيبة سفر",
  "Travel Bags & Luggage": "حقائب سفر وأمتعة",
  "Travel Wallets": "محافظ سفر",
  "Treadmills": "جهاز المشي",
  "Trench": "خندق",
  "Trendy Claw Clips": "مشابك أظافر عصرية",
  "Trendy Hair Clips": "مشابك شعر عصرية",
  "Trendy Sunglasses": "نظارات شمسية عصرية",
  "Trendy Wigs": "باروكات عصرية",
  "Turbos, Nitrous & Superchargers": "توربو، نيترو وأجهزة شحن مُحسّنة",
  "Turning Tool": "أداة تحويل",
  "Turtleneck": "قميص بياقة طويلة",
  "Turtlenecks": "قمصان ياقة طويلة",
  "U-Part Wigs": "باروكات بفتح U",
  "Ukulele": "عود صغير",
  "Ultrasonic Cleaner": "منظف بالموجات فوق الصوتية",
  "Ultrasonic Scaler": "جهاز قياس بالموجات فوق الصوتية",
  "Undershirts": "قمصان داخلية",
  "Used Phones": "هواتف مستعملة",
  "Utensils": "أدوات",
  "Vacuum Mite Remover": "جهاز إزالة العثة بالشفط",
  "Valves": "صمامات",
  "Vents": "فواصل هوائية",
  "Vest": "سترة بدون أكمام",
  "Vests & Waistcoats": "سترات وقمصان بدلات",
  "Video Game Consoles": "وحدات ألعاب الفيديو",
  "Video Intercom": "جهاز إنتركوم فيديو",
  "Video Surveillance": "مراقـبة بالفيديو",
  "Waist Chain": "سلسلة الخصر",
  "Waist Cinchers": "مشدات الخصر",
  "Waist Packs": "حقائب الخصر",
  "Waiter Uniforms": "زي النادل",
  "Waiting Chairs": "كراسي الانتظار",
  "Walkers": "الماشي",
  "Walkie Talkie": "جهاز اتصال لاسلكي",
  "Walkie Talkie Accessories": "ملحقات جهاز الاتصال اللاسلكي",
  "Wall Panels": "لوحات الجدران",
  "Wallet & ID Holder": "محفظة وهولدر الهوية",
  "Wallpapers": "خلفيات الجدران",
  "Warm Boots": "أحذية دافئة",
  "Washed leans": "جينز مغسول",
  "Watch Cases": "حافظات الساعات",
  "Watch Winders": "أجهزة تعبئة الساعات الأوتوماتيكية",
  "Watchbands": "أساور الساعات",
  "Watches": "ساعات",
  "Water Dispenser": "موزع ماء",
  "Water Filters": "فلاتر مياه",
  "Water Filtration": "تنقية المياه",
  "Water Guns, Blasters & Soakers": "بنادق المياه وآلات الرش والرشاشات",
  "Water Play Equipment": "معدات اللعب في الماء",
  "Water Purifier": "منقي مياه",
  "Watering & lrrigation": "ريّ وريّ المحاصيل",
  "Waterproof Backpack": "حقيبة ظهر مقاومة للماء",
  "Waterproof Wall Sticker": "ملصقات جدران مقاومة للماء",
  "Wax Heater": "سخان الشمع",
  "Wear Parts": "قطع التآكل",
  "Wedding Accessories": "إكسسوارات الزفاف",
  "Wedding Dress": "فساتين زفاف",
  "Wedding Dresses": "فساتين زفاف",
  "Wedding Party Dress": "فساتين حفل زفاف",
  "Wedge Heel": "كعب سميك",
  "Weight Benches": "مقاعد الأوزان",
  "Welding Equipment": "معدات اللحام",
  "Wheel Parts": "قطع العجلات",
  "Wheels & Flight Joysticks": "عجلات ومقود الطيران",
  "Wig Stands": "دوابط الباروكات",
  "Wigs": "باروكات",
  "Wildlife Camera": "كاميرا الحياة البرية",
  "Winches": "رافعات",
  "Window Door Sensor": "مستشعر باب النوافذ",
  "Window Foils & Solar Protection": "رقائق النوافذ وحماية من الشمس",
  "Windshield Wipers": "مساحات الزجاج الأمامي",
  "Winter Home Shoes": "أحذية منزلية شتوية",
  "Winter Socks": "جوارب شتوية",
  "Winter Warm Sleepwear": "ملابس نوم دافئة شتوية",
  "Wiring Accessories": "ملحقات الأسلاك",
  "Wok": "مقلاة صينية عميقة",
  "Women's Belts": "أحزمة للنساء",
  "Women's Boots": "أحذية للنساء",
  "Women's Casual Shoes": "أحذية غير رسمية للنساء",
  "Women's Clothing": "ملابس نسائية",
  "Women's Fold Wallet": "محفظة قابلة للطي للنساء",
  "Women's Necklace": "قلادة للنساء",
  "Women's Pants": "سراويل للنساء",
  "Women's Sandals & Slippers": "صندل وشبشب للنساء",
  "Women's Sunglasses": "نظارات شمسية للنساء",
  "Wooden Blocks": "كتل خشبية",
  "Wool & Blends Coats": "معاطف من الصوف والمزيج",
  "Work & Safety Shoes": "أحذية عمل وسلامة",
  "Work Wear & Uniforms": "ملابس العمل والزي الرسمي",
  "Workplace Safety Supplies": "لوازم سلامة مكان العمل",
  "Writing & Correction Supplies": "لوازم الكتابة والتصحيح",
  "Writing Pad": "دفتر كتابة",
  "Yoyo": "يويو",
  "Zipper Bag": "حقيبة بسحاب",
  "We noticed you haven't verified your email address. Go to verify now?": "لاحظنا أنك لم تُثبّت بريدك الإلكتروني. هل تريد التحقق الآن؟",
  "We noticed you haven't bind your mobile phone. Go to complete now?": "لاحظنا أنك لم تُربط هاتفك. هل تريد إكمال العملية الآن؟",
  "Phone is not bind": "الهاتف غير مقيد",
  "English": "إنجليزي",
  "Portuguese": "البرتغالية",
  "Arabic": "عربي",
  "Supplier Team": "فريق الموردين",
  "Hosting": "استضافة",

  "Upload file header line error": "خطأ في سطر رأس ملف التحميل",
  "Data is empty": "البيانات فارغة",
  "ResetPassword": "إعادة تعيين كلمة المرور",
  "Accesses": "الوصولات",
  "Client Name": "اسم العميل",
  "Initial password": "كلمة المرور الأولية",
  "Alias Name": "الاسم المستعار",
  "Store type": "نوع المتجر",
  "Store URL": "عنوان URL للمتجر",
  "Token": "الرمز",
  "Secret key": "المفتاح السري",
  "Reauthorization": "إعادة التفويض",
  "Clients": "العملاء",
  "Adm access": "وصول الإدارة",
  "REGISTER": "يسجل",
  "Please enter your email address": "الرجاء إدخال عنوان بريدك الإلكتروني",
  "Please input password": "الرجاء إدخال كلمة المرور",
  "Password": "كلمة المرور",
  "Slide to get your CAPTCHA": "مرر للحصول على رمز التحقق الخاص بك",
  "Please fill in email address as your username": "الرجاء إدخال عنوان البريد الإلكتروني كاسم المستخدم الخاص بك",
  "Please fill in the CAPTCHA you received": "الرجاء ملء رمز التحقق الذي تلقيته",
  "Please set your password": "الرجاء تعيين كلمة المرور الخاصة بك",
  "Please confirm your password": "الرجاء تأكيد كلمة المرور الخاصة بك",
  "Password confirm": "تأكيد كلمة المرور",
  "Please fill in the name": "الرجاء ملء الاسم",
  "Mobile": "متحرك",
  "Please Select": "الرجاء الاختيار",
  "Please set your mobile": "يرجى ضبط هاتفك المحمول",
  "Invitation Code": "رمز الدعوة",
  "Please confirm your code": "يرجى تأكيد الكود الخاص بك",
  "CREATE AN ACCOUNT": "إنشاء حساب",
  "Already had an account?": "هل لديك حساب بالفعل؟",

  "Change password": "تغيير كلمة المرور",
  "Please fill in your email address": "الرجاء إدخال عنوان بريدك الإلكتروني",
  "Please set your new password": "الرجاء تعيين كلمة المرور الجديدة الخاصة بك",
  "Please confirm your new password": "الرجاء إدخال عنوان بريدك الإلكتروني",
  "New password": "كلمة المرور الجديدة",
  "Confirm password must be filled in": "تأكيد كلمة المرور يجب أن يتم ملؤها",
  "Mobile must be filled in": "يجب ملء رقم الهاتف المحمول",
  "The password and confirm password must be the same": "يجب أن تكون كلمة المرور وتأكيد كلمة المرور متماثلتين",
  "Please select the country first": "الرجاء تحديد البلد أولا",
  "Please fill in the mobile": "يرجى ملء رقم الهاتف المحمول",
  "pre-order item inventory": "مخزون العناصر المطلوبة مسبقًا",
  "packing inventory": "مخزون التعبئة والتغليف",

  "Recharge Application": "تطبيق إعادة الشحن",
  "View History": "عرض التاريخ",
  "Recharge Records": "سجلات إعادة الشحن",
  "Payment-link Request": "طلب رابط الدفع",
  "Please select the payment method first": "الرجاء تحديد طريقة الدفع أولا",
  "Please fill in the amount.": "يرجى إدخال المبلغ.",

  "Channel": "قناة",
  "Top-up Request": "طلب إعادة الشحن",
  "Payment Method": "طريقة الدفع",
  "Upload Evidence": "تحميل الأدلة",
  "Evidence": "شهادة",
  "createdAt": "تم إنشاؤه في",
  "updatedAt": "تم التحديث في",
  "Too many pictures upload!": "تم تحميل الكثير من الصور!",
  "Put payment evidence": "ضع دليل الدفع",
  "Pay difference for order": "ادفع فرق السعر للطلب",
  "Pay for CPF checking": "ادفع رسوم حساب الضمان الاجتماعي",
  "Add bonus": "مكافأة إضافية",
  "Pay for other reason": "ادفع لسبب آخر",
  "Please fill the reason": "يرجى ملء السبب",

  "Wait for payment link": "انتظر رابط الدفع",
  "Wait for payment evidence": "انتظر إثبات الدفع",
  "Wait for review": "انتظر المراجعة",
  "Evidence Pass": "موافقة على الأدلة",
  "Evidence Reject": "رفض الأدلة",
  "Ticket Done": "تم تنفيذه",
  "Closed": "مغلق",
  "待复核": "قيد المراجعة",
  "待确认": "في انتظار الشيك",

  "Detail": "التفاصيل",
  "Wholesale": "بالجملة",
  "Wholesale Products": "منتجات",
  "Wholesale Favorites": "المفضلة",
  "Wholesale Cart": "عربة التسوق",
  "Wholesale Orders": "طلبات",
  "Add to cart": "أضف إلى السلة",
  "Cart": "عربة التسوق",

  "BatchRestore": "استعادة الدفعة",
  "RestoreALL": "استعادة الكل",

}